(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["adobe-locales"] = factory();
	else
		root["adobe-locales"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegionDefaultLocale = exports.getCountryLanguages = exports.createLocaleFromIMS = exports.getAppNameFromURL = exports.isUmbrellaRegionApp = exports.getUmbrellaRegions = exports.getAllLocales = exports.stripUrl = exports.langScript = exports.normalize = exports.priuse = exports.regions = exports.region = exports.script = exports.extlang = exports.lang = exports.findValueByKeyIgnoreCase = exports.findKey = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*************************************************************************
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * ADOBE CONFIDENTIAL
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * ___________________
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         *  Copyright 2023 Adobe Systems Incorporated
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         *  All Rights Reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * NOTICE:  All information contained herein is, and remains
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * the property of Adobe Systems Incorporated and its suppliers,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * if any.  The intellectual and technical concepts contained
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * herein are proprietary to Adobe Systems Incorporated and its
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * suppliers and are protected by all applicable intellectual property
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * laws, including trade secret and copyright laws.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * Dissemination of this information or reproduction of this material
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * is strictly forbidden unless prior written permission is obtained
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         * from Adobe Systems Incorporated.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         **************************************************************************/

var _locales = __webpack_require__(3);

var locales = _interopRequireWildcard(_locales);

var _region2 = __webpack_require__(75);

var _region3 = _interopRequireDefault(_region2);

var _apps = __webpack_require__(2);

var _apps2 = _interopRequireDefault(_apps);

var _getAppLocale = __webpack_require__(1);

var _getAppLocale2 = _interopRequireDefault(_getAppLocale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var pattern = /^([a-zA-Z]{2})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?(?:-x-([a-zA-Z0-9]{1,8})(?=$))?$/;

var _match = function _match(locale) {
  return locale.match(pattern) || [];
};

/**
 * given an object, return its value based on passed condition
 * @param {object} obj
 * @param {object} fun
 */
var findKey = function findKey(obj, fun) {
  return Object.keys(obj).find(function (x) {
    return fun(obj[x]);
  });
};

/**
* given an object, return its value based on passed case-insensitive key
* @param {object} obj
* @param {string} key
*/
var findValueByKeyIgnoreCase = function findValueByKeyIgnoreCase(obj, key) {
  return key !== undefined ? obj[Object.keys(obj).filter(function (k) {
    return k.toLowerCase() === key.toLowerCase();
  })[0]] : undefined;
};

/* 
  https://www.w3.org/International/articles/language-tags/#rfc

  pattern: language-extlang-script-region-variant-extension-privateuse

  type      pattern
  language  2-letter or 3-letter
  extlang   3-letter
  script    4-letter
  region    2-letter or 3-number
  private   -x-****
*/
/**
 * "language" sub-tab of a locale
 * @param {string} locale - locale name
 */
var lang = function lang(locale) {
  return _match(locale)[1] || '';
};

/**
 * "extlang" sub-tab of a locale
 * @param {string} locale - locale name
 */
var extlang = function extlang(locale) {
  return _match(locale)[2] || '';
};

/**
 * "script" sub-tab of a locale
 * @param {string} locale - locale name
 */
var script = function script(locale) {
  return _match(locale)[3] || '';
};

/**
 * "region" sub-tab of a locale
 * @param {string} locale - locale name
 */
var region = function region(locale) {
  return _match(locale)[4] || '';
};

/**
 * "private use" sub-tab of a locale
 * @param {string} locale - locale name
 */
var priuse = function priuse(locale) {
  return _match(locale)[5] || '';
};

/**
 * "language" + "script" sub-tab of a locale
 * @param {string} locale - locale name
 * @param {string} camelizeScriptName - if camelize Script Name
 */
var langScript = function langScript(locale) {
  var camelizeScriptName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var ls = '';
  var matches = _match(locale);

  if (matches.length > 0) {
    if (matches[3] !== undefined) {
      // has script
      if (camelizeScriptName === true) {
        ls = matches[1] + '-' + matches[3].charAt(0).toUpperCase() + matches[3].slice(1);
      } else {
        ls = matches[1] + '-' + matches[3];
      }
    } else if (matches[1].toLowerCase() === 'zh' && matches[4] !== undefined) {

      var _region = matches[4].toLowerCase();

      if (['tw', 'hk', 'mo'].includes(_region)) {
        ls = 'zh-Hant';
      } else {
        ls = 'zh-Hans';
      }
    } else {
      ls = matches[1];
    }
  }

  return ls;
};

/*
  Generate all app locale mapping.
*/
var allLocales = {};

Object.keys(locales).forEach(function (app) {
  var appLocales = locales[app];

  Object.keys(appLocales).forEach(function (appLocale) {
    var mappedLocale = appLocales[appLocale];
    // const lowerMappedLocale = mappedLocale.toLowerCase();

    allLocales[appLocale] = mappedLocale;

    if (allLocales[mappedLocale] === undefined) {
      allLocales[mappedLocale] = mappedLocale;
    }

    // if (allLocales[lowerMappedLocale] === undefined) {
    //   allLocales[lowerMappedLocale] = mappedLocale;
    // }
  });
});

/**
 * get all app locale mapping
 */
var getAllLocales = function getAllLocales() {
  return allLocales;
};

/**
 * get all app locale mapping
 */
var getUmbrellaRegions = function getUmbrellaRegions(region, app) {
  return findKey(_apps.umbrellaRegions, function (v) {
    if (Array.isArray(v)) {
      return v.includes(region.toLowerCase());
    }

    return v[['adobedotcom', 'helpx'].includes(app) ? 'adobedotcom' : 'generic'].includes(region.toLowerCase());
  });
};

/**
 * check if one of apps that have Umbrella Regions such as "mena", "sea"
 */
var isUmbrellaRegionApp = function isUmbrellaRegionApp(app) {
  return _apps.umbrellaRegionApp.includes(app);
};

/**
 * returns BCP-47 form of a locale
 * @param {string} locale - locale name
 * @param {string} app - optional, which can handle app-specific case, like "uk" returns "en-GB" for app "adobedotcom", while it returns "uk-UA" in other cases.
 */
var normalize = function normalize(locale, app) {
  var normalizedLocale = void 0;

  if (app) {
    var appLocale = (0, _getAppLocale2.default)(app, locale);

    normalizedLocale = locales[app][appLocale];
  }

  return normalizedLocale || findValueByKeyIgnoreCase(getAllLocales(), locale);
};

/**
 * helps to construct a locale using the language of an app and the user's IMS country. 
 * If the language is not supported by adobe.com for that country, it will change to the 
 * default language of that country that adobe.com supports. For example, if en-US is the 
 * app language and JP is the IMS code, this will result in "ja-JP"
 */
var createLocaleFromIMS = function createLocaleFromIMS(locale, imsCountryCode) {
  var match = false;
  var newLocale = 'en-US';

  if (typeof locale === 'string' && typeof imsCountryCode === 'string' && imsCountryCode.length === 2) {
    var language = langScript(locale, true);
    var imsCountryCodeU = imsCountryCode.toUpperCase();
    var countryLangs = _region3.default[imsCountryCodeU];

    if (countryLangs !== undefined) {
      if (countryLangs.includes(language)) {
        match = true;
      } else {
        language = countryLangs[0] || 'en';
      }

      newLocale = language + '-' + imsCountryCodeU;
    }
  }

  return {
    match: match,
    locale: newLocale
  };
};

/**
 * helper to strip url protocol and www
 * @param {string} url - url name
 * @returns {string} url w/o protocol and www
 */
var stripUrl = function stripUrl(url) {
  return url.replace(/^https?:\/\//, '').replace(/^www\./, '');
};

/**
 * get app code name from a url
 * @param {string} url - url name
 * @returns {string} app name
 */
var getAppNameFromURL = function getAppNameFromURL(url) {
  var withAppBaseURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


  if (typeof url === 'string' && url.length) {
    var strippedUrl = stripUrl(url.trim().toLowerCase());

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _apps2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = _slicedToArray(_step.value, 2),
            name = _step$value[0],
            props = _step$value[1];

        var productionURLs = props.production ? Array.isArray(props.production) ? props.production : [props.production] : [];
        var stageURLs = props.stage ? Array.isArray(props.stage) ? props.stage : [props.stage] : [];

        var _arr = [].concat(_toConsumableArray(productionURLs), _toConsumableArray(stageURLs));

        for (var _i = 0; _i < _arr.length; _i++) {
          var appURL = _arr[_i];
          var strippedAppUrl = stripUrl(appURL);

          if (strippedUrl.indexOf(strippedAppUrl) === 0) {
            return withAppBaseURL === true ? { name: name, appBaseURL: strippedAppUrl.split('/')[0] } : name;
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return undefined;
};

/**
 * 
 * @param {string} region - 2 char country code
 * @returns default locale
 */
var getRegionDefaultLocale = function getRegionDefaultLocale(region) {
  var defaultLocale = void 0;

  if (typeof region === 'string' && region.length === 2) {
    var regionCode = region.toUpperCase();

    if (_region3.default[regionCode] && _region3.default[regionCode][0]) {
      var _lang = _region3.default[regionCode][0];

      defaultLocale = _lang + '-' + regionCode;
    }
  }

  return defaultLocale;
};

/**
 * get country supported languages list
 * @param {string} imsCountryCode - country code 2-char
 * @returns {array} languages list. default to ['en']
 */
var getCountryLanguages = function getCountryLanguages(imsCountryCode) {
  var defaultLangs = ['en'];
  var langs = typeof imsCountryCode === 'string' ? _region3.default[imsCountryCode.toUpperCase()] || [] : defaultLangs;

  return langs.length ? langs : defaultLangs;
};

exports.findKey = findKey;
exports.findValueByKeyIgnoreCase = findValueByKeyIgnoreCase;
exports.lang = lang;
exports.extlang = extlang;
exports.script = script;
exports.region = region;
exports.regions = _region3.default;
exports.priuse = priuse;
exports.normalize = normalize;
exports.langScript = langScript;
exports.stripUrl = stripUrl;
exports.getAllLocales = getAllLocales;
exports.getUmbrellaRegions = getUmbrellaRegions;
exports.isUmbrellaRegionApp = isUmbrellaRegionApp;
exports.getAppNameFromURL = getAppNameFromURL;
exports.createLocaleFromIMS = createLocaleFromIMS;
exports.getCountryLanguages = getCountryLanguages;
exports.getRegionDefaultLocale = getRegionDefaultLocale;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locales = __webpack_require__(3);

var locales = _interopRequireWildcard(_locales);

var _utils = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * @param {string} app - app code. For a complete apps code, see https://git.corp.adobe.com/intl/adobe-locales#supported-apps
 * @param {string} locale - locale name, it does not have to be the one destination app uses.
 * @param {string} fallback - fallback locale name, it does not have to be the one destination app uses.
 * @returns {string} destination app locale name. Returns "" if passed locale is not supported in the app. 
 */
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2023 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe Systems Incorporated and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Adobe Systems Incorporated and its
* suppliers and are protected by all applicable intellectual property
* laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe Systems Incorporated.
**************************************************************************/

var getAppLocale = function getAppLocale(app, locale, fallback) {
  // must be a valid app
  if (locales[app] === undefined) {
    console.warn('[@intl/adobe-locales] App "' + app + '" is not supported. Please refer to https://git.corp.adobe.com/intl/adobe-locales#supported-apps');
    return '';
  }

  // test locale
  if (typeof locale === 'string' && locale.substring(0, 2) === 'zz') {
    var en = getAppLocale(app, 'en-US');

    return en.includes('-') ? 'zz-ZZ' : en.includes('_') ? 'zz_ZZ' : 'zz';
  }

  var appLocale = void 0;

  // exact locale
  if (locale && locales[app][locale] !== undefined) {
    appLocale = locale;
  } else {

    // otherwise find a match in all locales
    var adobeLocales = (0, _utils.getAllLocales)();

    if (locale && !((0, _utils.lang)(locale) === '' && adobeLocales[locale] === undefined)) {
      var normalizedLocale = (0, _utils.findValueByKeyIgnoreCase)(adobeLocales, locale);

      if (normalizedLocale === undefined) {
        if (locale.length === 2) {
          // region code or lang code only
          normalizedLocale = (0, _utils.getRegionDefaultLocale)(locale) || locale;
        } else {
          normalizedLocale = locale.includes('_') ? locale.replace(/_/g, '-') : locale;
        }
      }

      appLocale = (0, _utils.findKey)(locales[app], function (v) {
        return v === normalizedLocale;
      });

      // try umbrella regions
      if (appLocale === undefined && (0, _utils.isUmbrellaRegionApp)(app)) {
        var umbrellaRegion = (0, _utils.getUmbrellaRegions)((0, _utils.region)(locale), app);

        if (umbrellaRegion) {
          // try lang and region combination first
          var regionLocaleX = (0, _utils.lang)(locale) + '-x-' + umbrellaRegion.toUpperCase();
          var regionLocale = locale.slice(0, -2) + umbrellaRegion.toUpperCase();

          appLocale = (0, _utils.findKey)(locales[app], function (v) {
            return v === regionLocaleX || v === regionLocale;
          });
          // try region only
          if (appLocale === undefined && locales[app][umbrellaRegion] !== undefined) {
            appLocale = umbrellaRegion;
          }
        }
      }

      // try lang and script combination
      if (appLocale === undefined && (0, _utils.script)(normalizedLocale) !== '') {
        var withScript = normalizedLocale.substr(0, 7).toLowerCase();

        appLocale = (0, _utils.findKey)(locales[app], function (v) {
          return v.substr(0, 7).toLowerCase() === withScript;
        });
      }

      // try lang only
      if (appLocale === undefined) {
        // Checks Locale code's hyphen position. Cannot assume that language code is 2 because 'fil-PH' is 3.
        var hyphenPos = normalizedLocale.indexOf('-') !== -1 ? normalizedLocale.indexOf('-') : 2;
        var onlyLang = normalizedLocale.substr(0, hyphenPos).toLowerCase();

        appLocale = (0, _utils.findKey)(locales[app], function (v) {
          return v.substr(0, hyphenPos).toLowerCase() === onlyLang;
        });
      }

      // finally try region only
      if (appLocale === undefined) {
        var onlyRegion = normalizedLocale.split('-').pop().toLowerCase();

        appLocale = (0, _utils.findKey)(locales[app], function (v) {
          return v.substr(v.length - onlyRegion.length, onlyRegion.length).toLowerCase() === onlyRegion;
        });
      }
    }

    if (appLocale === undefined && fallback !== undefined) {
      appLocale = (0, _utils.findKey)(locales[app], function (v) {
        return v === fallback || v === adobeLocales[fallback];
      });
    }
  }

  // stock has nothing for en-US locale
  if (app === 'stock' && appLocale === 'us') {
    appLocale = '';
  }

  return appLocale || '';
};

exports.default = getAppLocale;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var apps = new Map(Object.entries({
  'academic_verification': {
    'stage': 'https://commerce-stg.adobe.com/academic-verification',
    'production': 'https://commerce.adobe.com/academic-verification'
  },
  'acrobat_plan': {
    'stage': 'https://stage.acrobat.adobe.com/proxy/pricing',
    'production': 'https://acrobat.adobe.com/proxy/pricing'
  },
  'acrobat_web': {
    'stage': 'https://stage.acrobat.adobe.com',
    'production': 'https://acrobat.adobe.com'
  },
  'adobeaccount': {
    'stage': 'https://stage.account.adobe.com',
    'production': 'https://account.adobe.com'
  },
  'adminconsole': {
    'stage': 'https://stage.adminconsole.adobe.com',
    'production': 'https://adminconsole.adobe.com'
  },
  'assets': {
    'stage': 'https://assets-stage.adobecc.com',
    'production': 'https://assets.adobe.com'
  },
  'aura': {
    'stage': 'https://stage.aura.corp.adobe.com',
    'production': ['https://aura.corp.adobe.com']
  },
  'behance': {
    'stage': 'https://net.s2stagehance.com',
    'production': 'https://www.behance.net'
  },
  'adobehome': {
    'stage': ['https://www.stage.adobe.com/home', 'https://www.stage.adobe.com/apps'],
    'production': ['https://www.adobe.com/home', 'https://www.adobe.com/apps']
  },
  'cchome': {
    'stage': 'https://stage.creativecloud.adobe.com',
    'production': 'https://creativecloud.adobe.com'
  },
  'color': {
    'stage': 'https://colorweb-stage.adobeku.com',
    'production': 'https://color.adobe.com'
  },
  'community': {
    'stage': 'https://community-stg.adobe.com',
    'production': 'https://community.adobe.com'
  },
  'creativecloudapp': {
    'stage': 'https://stage.ccmui.adobe.com',
    'production': 'https://creative.adobe.com'
  },
  'dcweb': {
    'stage': 'https://dc.stage.acrobat.com',
    'production': 'https://documentcloud.adobe.com'
  },
  'experiencecloud': {
    'stage': 'https://experiencecloud-stage.adobe.com',
    'production': 'https://experiencecloud.adobe.com'
  },
  'firefly': {
    'stage': 'https://firefly-stage.corp.adobe.com',
    'production': 'https://firefly.adobe.com'
  },
  'firefly_nonprod': {
    'stage': 'https://firefly-stage.corp.adobe.com',
    'dev': 'https://firefly-dev.corp.adobe.com'
  },
  'frameio': {
    'stage': 'https://support.frame.io',
    'production': 'https://support.frame.io'
  },
  'fonts': {
    'stage': 'https://fonts-relstage.adobe.com',
    'production': 'https://fonts.adobe.com'
  },
  'glaas': {
    'stage': 'https://glaas.corp.adobe.com/#/home',
    'production': 'https://glaas.corp.adobe.com/#/home'
  },
  'helpx': {
    'stage': 'https://helpx.stage.adobe.com',
    'production': 'https://helpx.adobe.com'
  },
  'ims': {
    'stage': 'https://ims-na1-stg1.adobelogin.com',
    'production': 'https://adobeid-na1.services.adobe.com'
  },
  'lightroom': {
    'stage': 'https://stage.adobelr.com',
    'production': 'https://lightroom.adobe.com'
  },
  'mini_plans': {
    'stage': 'https://www.stage.adobe.com/mini-plans',
    'production': 'https://www.adobe.com/mini-plans'
  },
  'ngl': {
    'stage': 'https://workflow-stage.licenses.adobe.com',
    'production': 'https://workflow.licenses.adobe.com'
  },
  'psweb': {
    'stage': 'https://stage.photoshop.adobe.com',
    'production': 'https://photoshop.adobe.com'
  },
  'portfolio': {
    'stage': 'https://portfolio.ccpsx.com',
    'production': 'https://portfolio.adobe.com'
  },
  'projectx': {
    'stage': 'https://stage.projectx.corp.adobe.com',
    'production': ['https://preview.projectx.corp.adobe.com', 'https://projectx.corp.adobe.com', 'https://new.express.adobe.com'],
    'regions': ['AU', 'BR', 'CO', 'DE', 'ES', 'FR', 'ID', 'IN', 'IT', 'JP', 'KR', 'MX', 'TH', 'GB', 'US', 'ZZ']
  },
  'projectx_nonprod': {
    'stage': 'https://stage.projectx.corp.adobe.com',
    'dev': ['https://dev.projectx.corp.adobe.com'],
    'regions': ['AU', 'BR', 'CO', 'DE', 'ES', 'FR', 'ID', 'IN', 'IT', 'JP', 'KR', 'MX', 'TH', 'GB', 'US', 'ZZ']
  },
  'redemption_ui': {
    'stage': 'https://redeem-stg.adobe.com',
    'production': 'https://redeem.adobe.com'
  },
  'stock': {
    'stage': 'https://primary.stock.stage.adobe.com',
    'production': 'https://stock.adobe.com'
  },
  'stock_contributor': {
    'stage': 'https://contributor.stock.stage.adobe.com',
    'production': 'https://contributor.stock.adobe.com'
  },
  'spark': {
    'stage': 'https://express-stage.adobe.com',
    'production': ['https://spark.adobe.com', 'https://express.adobe.com']
  },
  's3diweb': {
    'stage': ['https://dev.substance3d.adobe.com/assets', 'https://dev.substance3d.adobe.com/community-assets', 'https://dev.substance3d.adobe.com/tutorials'],
    'production': 'https://substance3d.adobe.com'
  },
  's3diwebviewer': {
    'stage': ['https://rte-web-viewer-develop.dev.substance3d.io', 'https://rte-web-viewer-beehive.dev.substance3d.io'],
    'production': ['https://rte-web-viewer.substance3d.com']
  },
  'commerce_ui': {
    'stage': 'https://commerce-stg.adobe.com',
    'production': 'https://commerce.adobe.com'
  },
  'unifiedcheckout': {
    'stage': 'https://commerce-stg.adobe.com',
    'production': 'https://commerce.adobe.com'
  },
  'unfurl': {
    'stage': 'N/A',
    'production': 'N/A'
  },
  'xd': {
    'stage': 'https://stage.xd.adobe.com',
    'production': 'https://xd.adobe.com'
  },
  'adobedotcom': {
    'stage': 'https://www.stage.adobe.com',
    'production': 'https://www.adobe.com'
  }
}));

// includes all apps that has locale as part of URL path, like "https://www.adobe.com/us/", compapred to query param like "https://cchome.adobe.com/?locale=en"
var urlApp = exports.urlApp = ['adobedotcom', 'helpx', 'spark', 'stock_contributor', 'stock', 'accountmanagement', 'creativecloudapp', 'ngl', 'color', 'mini_plans', 'frameio'];

// includes all apps that use "lang" as query param instead of "locale"
var langParamApp = exports.langParamApp = ['adobeaccount', 'redemption_ui', 'unifiedcheckout', 'academic_verification', 'community', 'psweb', 's3diweb', 's3diwebviewer'];

// includes all apps that use umbrella regions
var umbrellaRegionApp = exports.umbrellaRegionApp = ['adobedotcom', 'helpx', 'globalnav', 'ims', 'acrobat_plan', 'ngl', 'jarvis', 'mini_plans'];

var umbrellaRegions = exports.umbrellaRegions = {
  africa: {
    'generic': ['africa', 'ao', 'bf', 'bi', 'bj', 'bw', 'cd', 'cf', 'cg', 'ci', 'cm', 'cv', 'dj', 'er', 'et', 'ga', 'gh', 'gm', 'gn', 'gq', 'gw', 'ke', 'km', 'lr', 'ls', 'mg', 'ml', 'mu', 'mw', 'mz', 'na', 'ne', 'ng', 'rw', 'sc', 'sd', 'sl', 'sn', 'so', 'st', 'sz', 'td', 'tg', 'tz', 'ug', 'za', 'zm', 'zw'],
    'adobedotcom': ['africa', 'ao', 'bf', 'bi', 'bj', 'bw', 'cd', 'cf', 'cg', 'ci', 'cm', 'cv', 'dj', 'er', 'et', 'ga', 'gh', 'gm', 'gn', 'gq', 'gw', 'ke', 'km', 'lr', 'ls', 'mg', 'ml', 'mu', 'mw', 'mz', 'na', 'ne', 'rw', 'sc', 'sd', 'sl', 'sn', 'so', 'st', 'sz', 'td', 'tg', 'tz', 'ug', 'za', 'zm', 'zw'],
    'mini_plans': ['africa', 'ao', 'bf', 'bi', 'bj', 'bw', 'cd', 'cf', 'cg', 'ci', 'cm', 'cv', 'dj', 'er', 'et', 'ga', 'gh', 'gm', 'gn', 'gq', 'gw', 'ke', 'km', 'lr', 'ls', 'mg', 'ml', 'mu', 'mw', 'mz', 'na', 'ne', 'rw', 'sc', 'sd', 'sl', 'sn', 'so', 'st', 'sz', 'td', 'tg', 'tz', 'ug', 'za', 'zm', 'zw']
  },
  cis: ['cis', 'by', 'kg', 'kz', 'tj', 'uz'],
  la: {
    'generic': ['la', 'ar', 'bl', 'bo', 'br', 'bz', 'cl', 'co', 'cr', 'cu', 'do', 'ec', 'fk', 'gf', 'gt', 'gy', 'hn', 'ht', 'mf', 'mq', 'ni', 'pa', 'pe', 'pr', 'py', 'sr', 'sv', 'uy', 've', 'tt'],
    'adobedotcom': ['la', 'bl', 'bo', 'br', 'bz', 'cl', 'cr', 'cu', 'do', 'fk', 'gf', 'gy', 'hn', 'ht', 'mf', 'mq', 'ni', 'pa', 'py', 'sr', 'sv', 'uy', 've', 'tt']
  },
  mena: {
    'generic': ['mena', 'ae', 'bh', 'dz', 'eg', 'jo', 'kw', 'lb', 'ma', 'om', 'qa', 'sa', 'tn', 'ye', 'iq', 'ly', 'mr'],
    'adobedotcom': ['mena', 'ae', 'bh', 'dz', 'jo', 'lb', 'ma', 'om', 'sa', 'tn', 'ye', 'iq', 'ly', 'mr'],
    'mini_plans': ['mena', 'bh', 'dz', 'jo', 'lb', 'ma', 'om', 'tn', 'ye', 'iq', 'ly', 'mr']
  },
  sea: {
    'generic': ['sea', 'id', 'my', 'ph', 'sg', 'th', 'vn', 'lk'],
    'adobedotcom': ['sea', 'sg', 'lk']
  },
  hk: ['mo'],
  ie: ['hr', 'cy', 'mt']
};

exports.default = apps;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ucv = __webpack_require__(8);

Object.defineProperty(exports, 'academic_verification', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ucv).default;
  }
});

var _account_menu = __webpack_require__(9);

Object.defineProperty(exports, 'account_menu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_account_menu).default;
  }
});

var _adminconsole = __webpack_require__(10);

Object.defineProperty(exports, 'adminconsole', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adminconsole).default;
  }
});

var _adobeaccount = __webpack_require__(11);

Object.defineProperty(exports, 'adobeaccount', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adobeaccount).default;
  }
});

var _adobedotcom = __webpack_require__(12);

Object.defineProperty(exports, 'adobedotcom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adobedotcom).default;
  }
});

var _acrobat_plan = __webpack_require__(13);

Object.defineProperty(exports, 'acrobat_plan', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_acrobat_plan).default;
  }
});

var _dcweb = __webpack_require__(14);

Object.defineProperty(exports, 'acrobat_web', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dcweb).default;
  }
});

var _acrs = __webpack_require__(15);

Object.defineProperty(exports, 'acrs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_acrs).default;
  }
});

var _assets = __webpack_require__(16);

Object.defineProperty(exports, 'assets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_assets).default;
  }
});

var _aura = __webpack_require__(17);

Object.defineProperty(exports, 'aura', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_aura).default;
  }
});

var _behance = __webpack_require__(18);

Object.defineProperty(exports, 'behance', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_behance).default;
  }
});

var _business_essentials = __webpack_require__(19);

Object.defineProperty(exports, 'business_essentials', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_business_essentials).default;
  }
});

var _quick_actions = __webpack_require__(20);

Object.defineProperty(exports, 'quick_actions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_quick_actions).default;
  }
});

var _squirrel = __webpack_require__(21);

Object.defineProperty(exports, 'squirrel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_squirrel).default;
  }
});

var _cchome = __webpack_require__(4);

Object.defineProperty(exports, 'adobehome', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cchome).default;
  }
});
Object.defineProperty(exports, 'cchome', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cchome).default;
  }
});

var _cchome_learn = __webpack_require__(22);

Object.defineProperty(exports, 'cchome_learn', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cchome_learn).default;
  }
});

var _cchome_leftnav = __webpack_require__(23);

Object.defineProperty(exports, 'cchome_leftnav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cchome_leftnav).default;
  }
});

var _cclibrary = __webpack_require__(24);

Object.defineProperty(exports, 'cclibrary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cclibrary).default;
  }
});

var _ccsearch = __webpack_require__(25);

Object.defineProperty(exports, 'ccsearch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ccsearch).default;
  }
});

var _ccsurfaces = __webpack_require__(26);

Object.defineProperty(exports, 'ccsurfaces', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ccsurfaces).default;
  }
});

var _color = __webpack_require__(27);

Object.defineProperty(exports, 'color', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_color).default;
  }
});

var _comments = __webpack_require__(28);

Object.defineProperty(exports, 'comments', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_comments).default;
  }
});
Object.defineProperty(exports, 'commerce_ui', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ucv).default;
  }
});

var _community = __webpack_require__(29);

Object.defineProperty(exports, 'community', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_community).default;
  }
});

var _creativecloudapp = __webpack_require__(30);

Object.defineProperty(exports, 'creativecloudapp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_creativecloudapp).default;
  }
});

var _dva_voice = __webpack_require__(31);

Object.defineProperty(exports, 'dva_voice', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dva_voice).default;
  }
});
Object.defineProperty(exports, 'dcweb', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dcweb).default;
  }
});

var _editbilling = __webpack_require__(32);

Object.defineProperty(exports, 'editbilling', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_editbilling).default;
  }
});

var _experiencecloud = __webpack_require__(33);

Object.defineProperty(exports, 'experiencecloud', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_experiencecloud).default;
  }
});

var _firefly = __webpack_require__(34);

Object.defineProperty(exports, 'firefly', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_firefly).default;
  }
});

var _firefly_nonprod = __webpack_require__(35);

Object.defineProperty(exports, 'firefly_nonprod', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_firefly_nonprod).default;
  }
});

var _fonts = __webpack_require__(36);

Object.defineProperty(exports, 'fonts', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fonts).default;
  }
});

var _font_picker = __webpack_require__(37);

Object.defineProperty(exports, 'font_picker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_font_picker).default;
  }
});

var _frameio = __webpack_require__(38);

Object.defineProperty(exports, 'frameio', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_frameio).default;
  }
});

var _globalnav = __webpack_require__(39);

Object.defineProperty(exports, 'globalnav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_globalnav).default;
  }
});

var _glaas = __webpack_require__(40);

Object.defineProperty(exports, 'glaas', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_glaas).default;
  }
});
Object.defineProperty(exports, 'helpx', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adobedotcom).default;
  }
});

var _ims = __webpack_require__(41);

Object.defineProperty(exports, 'ims', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ims).default;
  }
});

var _ims_preferred_lang = __webpack_require__(42);

Object.defineProperty(exports, 'ims_preferred_lang', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ims_preferred_lang).default;
  }
});

var _lightroom = __webpack_require__(43);

Object.defineProperty(exports, 'lightroom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightroom).default;
  }
});

var _jarvis = __webpack_require__(44);

Object.defineProperty(exports, 'jarvis', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_jarvis).default;
  }
});

var _mcs = __webpack_require__(45);

Object.defineProperty(exports, 'mcs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mcs).default;
  }
});

var _mini_plans_photoshop_lightroom_start_trial = __webpack_require__(46);

Object.defineProperty(exports, 'mini_plans_photoshop_lightroom_start_trial', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mini_plans_photoshop_lightroom_start_trial).default;
  }
});

var _mini_plans = __webpack_require__(47);

Object.defineProperty(exports, 'mini_plans', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mini_plans).default;
  }
});

var _mt = __webpack_require__(48);

Object.defineProperty(exports, 'mt', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mt).default;
  }
});

var _ngl = __webpack_require__(49);

Object.defineProperty(exports, 'ngl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ngl).default;
  }
});

var _panellicensing = __webpack_require__(50);

Object.defineProperty(exports, 'panel_licensing', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_panellicensing).default;
  }
});

var _psweb = __webpack_require__(51);

Object.defineProperty(exports, 'psweb', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_psweb).default;
  }
});

var _portfolio = __webpack_require__(52);

Object.defineProperty(exports, 'portfolio', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_portfolio).default;
  }
});

var _projectx = __webpack_require__(53);

Object.defineProperty(exports, 'projectx', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_projectx).default;
  }
});

var _projectx_nonprod = __webpack_require__(54);

Object.defineProperty(exports, 'projectx_nonprod', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_projectx_nonprod).default;
  }
});

var _publiclinks = __webpack_require__(55);

Object.defineProperty(exports, 'publiclinks', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_publiclinks).default;
  }
});

var _react_spectrum = __webpack_require__(56);

Object.defineProperty(exports, 'react_spectrum', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_react_spectrum).default;
  }
});

var _redemptionui = __webpack_require__(57);

Object.defineProperty(exports, 'redemption_ui', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_redemptionui).default;
  }
});

var _sharesheet = __webpack_require__(58);

Object.defineProperty(exports, 'sharesheet', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sharesheet).default;
  }
});

var _spark = __webpack_require__(59);

Object.defineProperty(exports, 'spark', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_spark).default;
  }
});

var _stock = __webpack_require__(60);

Object.defineProperty(exports, 'stock', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stock).default;
  }
});

var _stock_api = __webpack_require__(61);

Object.defineProperty(exports, 'stock_api', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stock_api).default;
  }
});

var _stock_contributor = __webpack_require__(62);

Object.defineProperty(exports, 'stock_contributor', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stock_contributor).default;
  }
});

var _s3diweb = __webpack_require__(63);

Object.defineProperty(exports, 's3diweb', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_s3diweb).default;
  }
});

var _s3diweviewer = __webpack_require__(64);

Object.defineProperty(exports, 's3diwebviewer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_s3diweviewer).default;
  }
});
Object.defineProperty(exports, 'switchplan_app', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_adobeaccount).default;
  }
});

var _timeline = __webpack_require__(65);

Object.defineProperty(exports, 'timeline', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_timeline).default;
  }
});

var _unfurl = __webpack_require__(66);

Object.defineProperty(exports, 'unfurl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_unfurl).default;
  }
});
Object.defineProperty(exports, 'unifiedcheckout', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ucv).default;
  }
});

var _ucv2 = __webpack_require__(67);

Object.defineProperty(exports, 'unifiedcheckout_v1', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ucv2).default;
  }
});

var _unifiedpanel = __webpack_require__(68);

Object.defineProperty(exports, 'unifiedpanel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_unifiedpanel).default;
  }
});

var _uss = __webpack_require__(69);

Object.defineProperty(exports, 'uss', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_uss).default;
  }
});

var _universalnav = __webpack_require__(70);

Object.defineProperty(exports, 'universalnav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_universalnav).default;
  }
});

var _utilitynav = __webpack_require__(71);

Object.defineProperty(exports, 'utilitynav', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_utilitynav).default;
  }
});

var _ututs = __webpack_require__(72);

Object.defineProperty(exports, 'ututs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ututs).default;
  }
});

var _xd = __webpack_require__(73);

Object.defineProperty(exports, 'xd', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_xd).default;
  }
});

var _supplement = __webpack_require__(74);

Object.defineProperty(exports, '_supplement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_supplement).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'id': 'id-ID',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'vi': 'vi-VN',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getAppLocale = __webpack_require__(1);

var _getAppLocale2 = _interopRequireDefault(_getAppLocale);

var _utils = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @param {string} app - app code
 * @param {string} locale - locale name
 * @param {string} imsCountryCode - two-character IMS country code
 * @returns {{locale: string, match: boolean}}
 */
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2023 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe Systems Incorporated and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Adobe Systems Incorporated and its
* suppliers and are protected by all applicable intellectual property
* laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe Systems Incorporated.
**************************************************************************/

var getAppLocaleFromIMS = function getAppLocaleFromIMS(app, locale, imsCountryCode) {
  if (typeof app === 'string') {
    app = app.replace(/-/g, '_');
  }

  var _createLocaleFromIMS = (0, _utils.createLocaleFromIMS)(locale, imsCountryCode),
      newLocale = _createLocaleFromIMS.locale,
      match = _createLocaleFromIMS.match;

  var appLocale = (0, _getAppLocale2.default)(app, newLocale);

  // 1/18/2024: No longer needed as mini_plans supports more locales
  // we have to support mini_plans a different list (a few less) than adobe.com
  // https://jira.corp.adobe.com/browse/LS-7436
  // if (app === 'mini_plans' || app === 'mini_plans_photoshop_lightroom_start_trial') {
  //   match = match && (newLocale === normalize(appLocale, app));
  // }

  return {
    match: match,
    locale: appLocale
  };
};

exports.default = getAppLocaleFromIMS;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apps = __webpack_require__(2);

var _utils = __webpack_require__(0);

var _getAppLocale = __webpack_require__(1);

var _getAppLocale2 = _interopRequireDefault(_getAppLocale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @param {string} url - the destination app url
 * @param {string} locale - locale you want to pass, it doesn not have to be the one destination app uses.
 * @returns {string} destination app localized url
 */
var getLocalizedURL = function getLocalizedURL(url, locale) {

  try {
    if (typeof url !== 'string' || typeof locale !== 'string') {
      throw Error('expect "url" and "locale" to be string.');
    }

    url = url.trim();

    if (url.toLowerCase().includes('adobe.com/go/')) {
      return url;
    }

    var localizedUrl = url;

    var _getAppNameFromURL = (0, _utils.getAppNameFromURL)(url, true),
        app = _getAppNameFromURL.name,
        appBaseURL = _getAppNameFromURL.appBaseURL;

    if (app === undefined) {
      throw Error('this app is not supported yet: "' + url + '"');
    }

    var appLocale = (0, _getAppLocale2.default)(app, locale);

    if (appLocale) {
      var allLocales = (0, _utils.getAllLocales)();

      if (_apps.urlApp.includes(app)) {

        // remove english path as it doesn't work for adobe.com and helpx URL w/paths
        if (appLocale === 'en' || appLocale === 'us' || appLocale === 'en-US') {
          appLocale = '';
        }

        var pattern = appBaseURL + '/(.*?)(?=/|$)';
        var thisLocale = (url.match(pattern) || [])[1];

        if (thisLocale !== undefined && allLocales[thisLocale] !== undefined) {
          localizedUrl = url.replace(appBaseURL + '/' + thisLocale, appLocale === '' ? appBaseURL : appBaseURL + '/' + appLocale);
        } else {
          if (appLocale !== '') {
            localizedUrl = url.replace(appBaseURL, appBaseURL + '/' + appLocale);
          }

          // [ISENG-2617]: support HelpX User Guide URLs
          if (app === 'helpx' && url.includes('.ug.html')) {
            localizedUrl = localizedUrl.replace('.html/', '.html/' + appLocale + '/');
          }
        }
      } else {
        var paramName = _apps.langParamApp.includes(app) ? app === 'community' ? 'profile.language' : 'lang' : 'locale';

        var reg = new RegExp('(' + paramName + '=)(.*?)(?=&|$)');
        var loc = (url.match(reg) || [])[2];

        if (loc !== undefined) {
          localizedUrl = url.replace(reg, '$1' + appLocale);
        } else {
          localizedUrl = url + (url.includes('?') ? '&' : '?') + paramName + '=' + appLocale;
        }
      }
    }

    return localizedUrl;
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[getLocalizedURL] Error: ' + e.message);
    }
  }

  return url;
}; /*************************************************************************
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2023 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by all applicable intellectual property
   * laws, including trade secret and copyright laws.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
exports.default = getLocalizedURL;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(78)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getAppLocale = __webpack_require__(1);

Object.defineProperty(exports, 'getAppLocale', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getAppLocale).default;
  }
});

var _getAppLocales = __webpack_require__(76);

Object.defineProperty(exports, 'getAppLocales', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getAppLocales).default;
  }
});

var _getAppRegions = __webpack_require__(77);

Object.defineProperty(exports, 'getAppRegions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getAppRegions).default;
  }
});

var _getAppLocaleFromIMS = __webpack_require__(5);

Object.defineProperty(exports, 'getAppLocaleFromIMS', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getAppLocaleFromIMS).default;
  }
});

var _getLocalizedURL = __webpack_require__(6);

Object.defineProperty(exports, 'getLocalizedURL', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLocalizedURL).default;
  }
});

var _getLocalizedURLFromIMS = __webpack_require__(79);

Object.defineProperty(exports, 'getLocalizedURLFromIMS', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLocalizedURLFromIMS).default;
  }
});

var _parseLocaleParam = __webpack_require__(80);

Object.defineProperty(exports, 'parseLocaleParam', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_parseLocaleParam).default;
  }
});

var _utils = __webpack_require__(0);

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg': 'bg-BG',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'el': 'el-GR',
  'es': 'es-ES',
  'et': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'id': 'id-ID',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'ms': 'ms-MY',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'sl': 'sl-SI',
  'sv': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'vi': 'vi-VN',
  'zh-hant': 'zh-Hant-TW'
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar': 'ar-AE',
  'bg': 'bg-BG',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'el': 'el-GR',
  'es': 'es-ES',
  'et': 'et-EE',
  'fi': 'fi-FI',
  'fil': 'fil-PH',
  'fr': 'fr-FR',
  'id': 'id-ID',
  'he': 'he-IL',
  'hi': 'hi-IN',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'ms': 'ms-MY',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'sl': 'sl-SI',
  'sv': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'vi': 'vi-VN',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg': 'bg-BG',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'el': 'el-GR',
  'en': 'en-US',
  'es': 'es-ES',
  'et': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'id': 'id-ID',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'ms': 'ms-MY',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'sl': 'sl-SI',
  'sv': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'vi': 'vi-VN',
  'zh-cn': 'zh-Hans-CN',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar': 'ar-AE',
  'bg': 'bg-BG',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'el': 'el-GR',
  'es': 'es-ES',
  'et': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'id': 'id-ID',
  'he': 'he-IL',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'ms': 'ms-MY',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'sl': 'sl-SI',
  'sv': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'vi': 'vi-VN',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'mena_ar': 'ar-x-MENA', // Arabic (Middle East and North Africa)
  'ae_ar': 'ar-AE', // Arabic (United Arab Emirates)
  'eg_ar': 'ar-EG', // Arabic (Egypt)
  'sa_ar': 'ar-SA', // Arabic (Saudi Arabia)
  'kw_ar': 'ar-KW', // Arabic (Kuwait)
  'qa_ar': 'ar-QA', // Arabic (Qatar)
  'bg': 'bg-BG', // Bulgarian (Bulgaria)
  'cz': 'cs-CZ', // Czech (Czech Republic)
  'dk': 'da-DK', // Danish (Denmark)
  'de': 'de-DE', // German (Germany)
  'at': 'de-AT', // German (Austria)
  'ch_de': 'de-CH', // German (Switzerland)
  'lu_de': 'de-LU', // German (Luxembourg)
  'ph_fil': 'fil-PH', // Filipino (Philippines)
  'gr_el': 'el-GR', // Greek (Greece)
  'us': 'en-US', // English (United States) - Default Locale
  'ae_en': 'en-AE', // English (United Arab Emirates)
  'au': 'en-AU', // English (Australia)
  'be_en': 'en-BE', // English (Belgium)
  'ca': 'en-CA', // English (Canada)
  'uk': 'en-GB', // English (United Kingdom)
  'gr_en': 'en-GR', // English (Greece)
  'eg_en': 'en-EG', // English (Egypt)
  'hk_en': 'en-HK', // English (Hong Kong)
  'ie': 'en-IE', // English (Ireland)
  'il_en': 'en-IL', // English (Israel)
  'in': 'en-IN', // English (India)
  'kw_en': 'en-KW', // English (Kuwait) 
  'lu_en': 'en-LU', // English (Luxembourg)
  'ng': 'en-NG', // English (Nigeria)
  'nz': 'en-NZ', // English (New Zealand)
  'sa_en': 'en-SA', // English (Saudi Arabia)
  'sg': 'en-SG', // English (Singapore)
  'th_en': 'en-TH', // English (Thailand)
  'ph_en': 'en-PH', // English (Philippines)
  'qa_en': 'en-QA', // English (Qatar)
  'id_en': 'en-ID', // English (Indonesia)
  'my_en': 'en-MY', // English (Malaysia)
  'vn_en': 'en-VN', // English (Vietnam)
  'africa': 'en-x-AFRICA', // English (Africa)
  'cis_en': 'en-x-CIS', // English (Commonwealth of Independent States)
  'mena_en': 'en-x-MENA', // English (Middle East and North Africa)
  'sea': 'en-x-SEA', // English (Southeast Asia)
  'es': 'es-ES', // Spanish (Spain)
  'ec': 'es-EC', // Spanish (Ecuador)
  'gt': 'es-GT', // Spanish (Guatemala)
  'mx': 'es-MX', // Spanish (Mexico)
  'cl': 'es-CL', // Spanish (Chile)
  'ar': 'es-AR', // Spanish (Argentina)
  'co': 'es-CO', // Spanish (Colombia)
  'cr': 'es-CR', // Spanish (Costa Rica)
  'pe': 'es-PE', // Spanish (Peru)
  'pr': 'es-PR', // Spanish (Puerto Rico)
  'la': 'es-x-LA', // Spanish (Latin America)
  'ee': 'et-EE', // Estonian (Estonia)
  'fi': 'fi-FI', // Finnish (Finland)
  'fr': 'fr-FR', // French (France)
  'be_fr': 'fr-BE', // French (Belgium)
  'ca_fr': 'fr-CA', // French (Canada)
  'ch_fr': 'fr-CH', // French (Switzerland)
  'lu_fr': 'fr-LU', // French (Luxembourg)
  'il_he': 'he-IL', // Hebrew (Israel)
  'hu': 'hu-HU', // Hungarian (Hungary)
  'in_hi': 'hi-IN', // Hindi (India)
  'id_id': 'id-ID', // Indonesian (Indonesia)
  'it': 'it-IT', // Italian (Italy)
  'ch_it': 'it-CH', // Italian (Switzerland)
  'jp': 'ja-JP', // Japanese (Japan)
  'kr': 'ko-KR', // Korean (Korea)
  'lt': 'lt-LT', // Lithuanian (Lithuania)
  'lv': 'lv-LV', // Latvian (Latvia)
  'my_ms': 'ms-MY', // Malay (Malaysia)
  'no': 'nb-NO', // Norwegian (Norway)
  'nl': 'nl-NL', // Dutch (Netherlands)
  'be_nl': 'nl-BE', // Dutch (Belgium)
  'pl': 'pl-PL', // Polish (Poland)
  'pt': 'pt-PT', // Portuguese (Portugal)
  'br': 'pt-BR', // Portuguese (Brazil)
  'ro': 'ro-RO', // Romanian (Romania)
  'ru': 'ru-RU', // Russian (Russia)
  'cis_ru': 'ru-x-CIS', // Russian (Commonwealth of Independent States)
  'sk': 'sk-SK', // Slovakian (Slovakia)
  'si': 'sl-SI', // Slovenian (Slovenia)
  'se': 'sv-SE', // Swedish (Sweden)
  'th_th': 'th-TH', // Thai (Thailand)
  'tr': 'tr-TR', // Turkish (Turkey)
  'ua': 'uk-UA', // Ukrainian (Ukraine)
  'vn_vi': 'vi-VN', // Vietnamese (Vietnam)
  'cn': 'zh-Hans-CN', // Chinese Simplified (China)
  'tw': 'zh-Hant-TW', // Chinese Traditional (Taiwan) 
  'hk_zh': 'zh-Hant-HK' // Chinese Traditional (Hong Kong)   
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'en-GB': 'en-GB',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'hu-HU': 'hu-HU',
  'sk-SK': 'sk-SK',
  'sl-SI': 'sl-SI',
  'uk-UA': 'uk-UA',
  'hr-HR': 'hr-HR',
  'ro-RO': 'ro-RO',
  'ca-ES': 'ca-ES',
  'eu-ES': 'eu-ES',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'en-GB': 'en-GB',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW',
  'eu-ES': 'eu-ES',
  'id-ID': 'id-ID',
  'ms-MY': 'ms-MY',
  'th-TH': 'th-TH',
  'vi-VN': 'vi-VN',
  'hr-HR': 'hr-HR',
  'sl-SI': 'sl-SI',
  'sk-SK': 'sk-SK',
  'uk-UA': 'uk-UA',
  'hu-HU': 'hu-HU',
  'is-IS': 'is-IS',
  'cy-GB': 'cy-GB'
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'cy-GB': 'cy-GB',
    'da-DK': 'da-DK',
    'de-DE': 'de-DE',
    'en-US': 'en-US',
    'es-ES': 'es-ES',
    'fi-FI': 'fi-FI',
    'fr-FR': 'fr-FR',
    'it-IT': 'it-IT',
    'ja-JP': 'ja-JP',
    'ko-KR': 'ko-KR',
    'nb-NO': 'nb-NO',
    'nl-NL': 'nl-NL',
    'pt-BR': 'pt-BR',
    'sv-SE': 'sv-SE',
    'zh-Hans-CN': 'zh-Hans-CN',
    'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'es_ES': 'es-ES',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pt_PT': 'pt-BR',
  'sv_SE': 'sv-SE',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bn-IN': 'bn-IN',
  'cs-CZ': 'cs-CZ',
  'cy-GB': 'cy-GB',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'el-GR': 'el-GR',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fil-PH': 'fil-PH',
  'fr-FR': 'fr-FR',
  'hi-IN': 'hi-IN',
  'hu-HU': 'hu-HU',
  'id-ID': 'id-ID',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'ms-MY': 'ms-MY',
  'nb-NO': 'nb-NO',
  'ne-NP': 'ne-NP',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ro-RO': 'ro-RO',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'ta-IN': 'ta-IN',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'vi-VN': 'vi-VN',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cy-GB': 'cy-GB',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pt-BR': 'pt-BR',
  'sv-SE': 'sv-SE',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _cchome = __webpack_require__(4);

var _cchome2 = _interopRequireDefault(_cchome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cchome_learn = _extends({}, _cchome2.default, {
  'hu': 'hu-HU',
  'uk': 'uk-UA'
});

exports.default = cchome_learn;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _cchome = __webpack_require__(4);

var _cchome2 = _interopRequireDefault(_cchome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cchome_leftnav = _extends({}, _cchome2.default, {
  'cy': 'cy-GB',
  'ms': 'ms-MY',
  'id': 'id-ID',
  'hu': 'hu-HU',
  'th': 'th-TH',
  'uk': 'uk-UA',
  'vi': 'vi-VN'
});

exports.default = cchome_leftnav;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'cy_GB': 'cy-GB',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'es_ES': 'es-ES',
  'es_MX': 'es-MX',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'fr_MA': 'fr-MA',
  'hu_HU': 'hu-HU',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'id': 'id-ID',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'vi': 'vi-VN',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'es_ES': 'es-ES',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'hu_HU': 'hu-HU',
  'id_ID': 'id-ID',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'th_TH': 'th-TH',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'vi_VN': 'vi-VN',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh': 'zh-Hant-TW'
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'cy': 'cy-GB',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fr': 'fr-FR',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'pt': 'pt-BR'
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-cn': 'zh-Hans-CN',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'da-dk': 'da-DK',
  'de-de': 'de-DE',
  'en-us': 'en-US',
  'en-gb': 'en-GB',
  'es-es': 'es-ES',
  'fr-fr': 'fr-FR',
  'hi-in': 'hi-IN',
  'it-it': 'it-IT',
  'ja-jp': 'ja-JP',
  'ko-kr': 'ko-KR',
  'pt-br': 'pt-BR',
  'pt-pt': 'pt-PT',
  'nb-no': 'nb-NO',
  'nl-nl': 'nl-NL',
  'sv-se': 'sv-SE',
  'ru-ru': 'ru-RU',
  'cmn-hans': 'zh-Hans-CN',
  'cmn-hant': 'zh-Hant-TW',
  'zh-hk': 'zh-Hant-HK'
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar': 'ar-AE',
  'bg': 'bg-BG',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'el': 'el-GR',
  'et': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'he': 'he-IL',
  'hu': 'hu-HU',
  'id': 'id-ID',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'ms': 'ms-MY',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'sl': 'sl-SI',
  'sv': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'vi': 'vi-VN',
  'zh-hans': 'zh-Hans-CN',
  'zh-hant': 'zh-Hant-TW'
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko-kr': 'ko-KR',
  'pt-br': 'pt-BR',
  'zh-cn': 'zh-Hans-CN',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-BL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pt-BR': 'pt-BR',
  'sv-SE': 'sv-SE',
  'ru-RU': 'ru-RU',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg-BG': 'bg-BG',
  'bn-IN': 'bn-IN',
  'cs-CZ': 'cs-CZ',
  'cy-GB': 'cy-GB',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'el-GR': 'el-GR',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fil-PH': 'fil-PH',
  'fr-FR': 'fr-FR',
  'hi-IN': 'hi-IN',
  'hr-HR': 'hr-HR',
  'hu-HU': 'hu-HU',
  'id-ID': 'id-ID',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'mr-IN': 'mr-IN',
  'ms-MY': 'ms-MY',
  'nb-NO': 'nb-NO',
  'ne-NP': 'ne-NP',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ro-RO': 'ro-RO',
  'ru-RU': 'ru-RU',
  'sr-SP': 'sr-SP',
  'sv-SE': 'sv-SE',
  'ta-IN': 'ta-IN',
  'te-IN': 'te-IN',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'vi-VN': 'vi-VN',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'ru': 'ru-RU',
  'pt-BR': 'pt-BR',
  'zh-CN': 'zh-Hans-CN'
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'mena_ar': 'ar-x-MENA', // Arabic (Middle East and North Africa)
  'ae_ar': 'ar-AE', // Arabic (United Arab Emirates)
  'sa_ar': 'ar-SA', // Arabic (Saudi Arabia)
  'bg': 'bg-BG', // Bulgarian (Bulgaria)
  'cz': 'cs-CZ', // Czech (Czech Republic)
  'dk': 'da-DK', // Danish (Denmark)
  'de': 'de-DE', // German (Germany)
  'at': 'de-AT', // German (Austria)
  'ch_de': 'de-CH', // German (Switzerland)
  'lu_de': 'de-LU', // German (Luxembourg)
  'us': 'en-US', // English (United States) - Default Locale
  'ae_en': 'en-AE', // English (United Arab Emirates)
  'au': 'en-AU', // English (Australia)
  'be_en': 'en-BE', // English (Belgium)
  'ca': 'en-CA', // English (Canada)
  'cy_en': 'en-CY', // English (Cyprus)
  'uk': 'en-GB', // English (United Kingdom)
  'gr_en': 'en-GR', // English (Greece)
  'hk_en': 'en-HK', // English (Hong Kong)
  'ie': 'en-IE', // English (Ireland)
  'il_en': 'en-IL', // English (Israel)
  'in': 'en-IN', // English (India)
  'lu_en': 'en-LU', // English (Luxembourg)
  'mt': 'en-MT', // English (Malta)
  'nz': 'en-NZ', // English (New Zealand)
  'sa_en': 'en-SA', // English (Saudi Arabia)
  'sg': 'en-SG', // English (Singapore)
  'th_en': 'en-TH', // English (Thailand)
  'africa': 'en-x-AFRICA', // English (Africa)
  'cis_en': 'en-x-CIS', // English (Commonwealth of Independent States)
  'mena_en': 'en-x-MENA', // English (Middle East and North Africa)
  'sea': 'en-x-SEA', // English (Southeast Asia)
  'es': 'es-ES', // Spanish (Spain)
  'mx': 'es-MX', // Spanish (Mexico)
  'cl': 'es-CL', // Spanish (Chile)
  'la': 'es-x-LA', // Spanish (Latin America)
  'ee': 'et-EE', // Estonian (Estonia)
  'fi': 'fi-FI', // Finnish (Finland)
  'fr': 'fr-FR', // French (France)
  'be_fr': 'fr-BE', // French (Belgium)
  'ca_fr': 'fr-CA', // French (Canada)
  'ch_fr': 'fr-CH', // French (Switzerland)
  'lu_fr': 'fr-LU', // French (Luxembourg)
  'il_he': 'he-IL', // Hebrew (Israel)
  'hu': 'hu-HU', // Hungarian (Hungary)
  'it': 'it-IT', // Italian (Italy)
  'ch_it': 'it-CH', // Italian (Switzerland)
  'jp': 'ja-JP', // Japanese (Japan)
  'kr': 'ko-KR', // Korean (Korea)
  'lt': 'lt-LT', // Lithuanian (Lithuania)
  'lv': 'lv-LV', // Latvian (Latvia)
  'no': 'nb-NO', // Norwegian (Norway)
  'nl': 'nl-NL', // Dutch (Netherlands)
  'be_nl': 'nl-BE', // Dutch (Belgium)
  'pl': 'pl-PL', // Polish (Poland)
  'pt': 'pt-PT', // Portuguese (Portugal)
  'br': 'pt-BR', // Portuguese (Brazil)
  'ro': 'ro-RO', // Romanian (Romania)
  'ru': 'ru-RU', // Russian (Russia)
  'cis_ru': 'ru-x-CIS', // Russian (Commonwealth of Independent States)
  'sk': 'sk-SK', // Slovakian (Slovakia)
  'si': 'sl-SI', // Slovenian (Slovenia)
  'se': 'sv-SE', // Swedish (Sweden)
  'th_th': 'th-TH', // Thai (Thailand)
  'tr': 'tr-TR', // Turkish (Turkey)
  'ua': 'uk-UA', // Ukrainian (Ukraine)
  'cn': 'zh-Hans-CN', // Chinese Simplified (China)
  'tw': 'zh-Hant-TW', // Chinese Traditional (Taiwan) 
  'hk_zh': 'zh-Hant-HK' // Chinese Traditional (Hong Kong)   
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* This is to match glaas search language param so it can be normalize
 in other apps for url building purpose */
exports.default = {
  'ar_AE': 'ar-AE',
  'bg_BG': 'bg-BG',
  'bn_IN': 'bn-IN',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'el_GR': 'el-GR',
  'en_US': 'en-US',
  'en_AE': 'en-AE',
  'en_AU': 'en-AU',
  'en_IE': 'en-IE',
  'en_IN': 'en-IN',
  'en_GB': 'en-GB',
  'en_IL': 'en-IL',
  'en_XM': 'en-x-MENA',
  'es_ES': 'es-ES',
  'es_LA': 'es-x-LA',
  'es_MX': 'es-MX',
  'es_NA': 'es-x-NA',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'fr_MA': 'fr-MA',
  'fr_XM': 'fr-x-MENA',
  'gu_IN': 'gu-IN',
  'hi_IN': 'hi-IN',
  'he_IL': 'he-IL',
  'hu_HU': 'hu-HU',
  'hr_HR': 'hr-HR',
  'id_ID': 'id-ID',
  'is_IS': 'is-IS',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'nb_NO': 'nb-NO',
  'ne_NP': 'ne-NP',
  'nl_BE': 'nl-BE',
  'ml_IN': 'ml-IN',
  'ms_MY': 'ms-MY',
  'nl_NL': 'nl-NL',
  'ph_PH': 'fil-PH',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sr_SP': 'sr-SP',
  'sv_SE': 'sv-SE',
  'ta_IN': 'ta-IN',
  'te_IN': 'te-IN',
  'th_TH': 'th-TH',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'vi_VN': 'vi-VN',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW',
  'zz_ZY': 'zz-ZY',
  'zz_ZZ': 'zz-ZZ'

  /* Glaas ->  "uk-UA", "en-IE", "sr-SP", "zz-ZZ", "zz-ZY", "lv-LV", "gu-IN", "ms-MY", "en-IN", "ceb-PH",
   "ta-IN", "en-ZA", "no-NO", "yo-NG", "el-GR", "te-IN", "zh-Hans", "nl-NL", "zh-Hant", "zu-ZA", "bhb-IN",
  "hi-IN", "en-AU", "mai-IN", "he-IL", "ar-TN", "de-CH", "ja-JP", "or-IN", "hu-HU", "ml-IN", "sd-IN", "ne-NP", 
  "as-IN", "eu-ES", "fr-CA", "nn-NO", "bho-IN", "jv-ID", "om-ET", "en-NZ", "pl-PL", "fa-IR", "pt-PT", "ro-RO", 
  "cy-GB", "en-SG", "et-EE", "tr-TR", "fil-PH", "fr-FR", "vi-VN", "en-GB", "ig-NG", "fi-FI", "nb-NO", "hr-HR", 
  "en-CA", "lt-LT", "ar-AE", "sl-SI", "is-IS", "bn-IN", "my-MM", "pa-IN", "bg-BG", "kn-IN", "es-US", "cs-CZ", 
  "ar-SA", "ca-ES", "de-DE", "zh-HK", "uz-UZ", "ko-KR", "pt-BR", "sk-SK", "sn-ZW", "sw-KE", "es-ES", "kk-KZ", 
  "so-SO", "ha-NG", "su-ID", "es-MX", "it-IT", "ur-IN", "ru-RU", "sv-SE", "id-ID", "tl-PH", "mr-IN", "am-ET", 
  "da-DK", "es-419", "th-TH" */

};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg_BG': 'bg-BG',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'el_GR': 'el-GR',
  'en_US': 'en-US',
  'en_AE': 'en-AE',
  'en_GB': 'en-GB',
  'en_HR': 'en-HR',
  'en_IL': 'en-IL',
  'en_KE': 'en-KE',
  'en_LK': 'en-LK',
  'en_MO': 'en-MO',
  'en_MU': 'en-MU',
  'en_NG': 'en-NG',
  'en_TT': 'en-TT',
  'en_VN': 'en-VN',
  'en_XM': 'en-x-MENA',
  'es_ES': 'es-ES',
  'es_BO': 'es-BO',
  'es_DO': 'es-DO',
  'es_LA': 'es-x-LA',
  'es_MX': 'es-MX',
  'es_NA': 'es-x-NA',
  'es_PA': 'es-PA',
  'es_PY': 'es-PY',
  'es_SV': 'es-SV',
  'es_UY': 'es-UY',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fil_PH': 'fil-PH',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'fr_MA': 'fr-MA',
  'fr_XM': 'fr-x-MENA',
  'hi_IN': 'hi-IN',
  'hr_HR': 'hr-HR',
  'hu_HU': 'hu-HU',
  'id_ID': 'id-ID',
  'in_ID': 'id-ID',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'ms_MY': 'ms-MY',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sr_RS': 'sr-RS',
  'sr_SP': 'sr-RS',
  'sv_SE': 'sv-SE',
  'th_TH': 'th-TH',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'vi_VN': 'vi-VN',
  'zh_HANS': 'zh-Hans-CN',
  'zh_CN': 'zh-Hans-CN',
  'zh_HANT': 'zh-Hant-TW',
  'zh_TW': 'zh-Hant-TW',
  'zh_MO': 'zh-Hant-MO'
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar-ae': 'ar-AE',
  'bg-bg': 'bg-BG',
  'cs-cz': 'cs-CZ',
  'da-dk': 'da-DK',
  'de-de': 'de-DE',
  'el-gr': 'el-GR',
  'en-us': 'en-US',
  'en-gb': 'en-GB',
  'en-il': 'en-IL',
  'es-es': 'es-ES',
  'es-la': 'es-x-LA',
  'es-mx': 'es-MX',
  'et-ee': 'et-EE',
  'fi-fi': 'fi-FI',
  'fr-fr': 'fr-FR',
  'fr-ca': 'fr-CA',
  'he-il': 'he-IL',
  'hr-hr': 'hr-HR',
  'hu-hu': 'hu-HU',
  'id-id': 'id-ID',
  'it-it': 'it-IT',
  'ja-jp': 'ja-JP',
  'ko-kr': 'ko-KR',
  'lt-lt': 'lt-LT',
  'lv-lv': 'lv-LV',
  'ms-my': 'ms-MY',
  'nb-no': 'nb-NO',
  'nl-nl': 'nl-NL',
  'pl-pl': 'pl-PL',
  'pt-br': 'pt-BR',
  'ro-ro': 'ro-RO',
  'ru-ru': 'ru-RU',
  'sk-sk': 'sk-SK',
  'sl-si': 'sl-SI',
  'sr-rs': 'sr-Latn-RS',
  'sv-se': 'sv-SE',
  'th-th': 'th-TH',
  'tr-tr': 'tr-TR',
  'uk-ua': 'uk-UA',
  'vi-vn': 'vi-VN',
  'zh-cn': 'zh-Hans-CN',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'en-GB': 'en-GB',
  'es-ES': 'es-ES',
  'es-MX': 'es-MX',
  'fr-FR': 'fr-FR',
  'fr-CA': 'fr-CA',
  'hu-HU': 'hu-HU',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nl-NL': 'nl-NL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'th-TH': 'th-TH',
  'uk-UA': 'uk-UA',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar_MENA': 'ar-x-MENA',
  'bg_BG': 'bg-BG',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'de_AT': 'de-AT',
  'de_CH': 'de-CH',
  'de_LU': 'de-LU',
  'en_US': 'en-US',
  'en_AU': 'en-AU',
  'en_BE': 'en-BE',
  'en_CA': 'en-CA',
  'en_CY': 'en-CY',
  'en_GB': 'en-GB',
  'en_GR': 'en-GR',
  'en_HK': 'en-HK',
  'en_IE': 'en-IE',
  'en_IL': 'en-IL',
  'en_IN': 'en-IN',
  'en_LU': 'en-LU',
  'en_MENA': 'en-x-MENA',
  'en_MT': 'en-MT',
  'en_NZ': 'en-NZ',
  'en_SEA': 'en-x-SEA',
  'en_ZA': 'en-x-AFRICA',
  'es_ES': 'es-ES',
  'es_LA': 'es-x-LA',
  'es_MX': 'es-MX',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_BE': 'fr-BE',
  'fr_CA': 'fr-CA',
  'fr_CH': 'fr-CH',
  'fr_LU': 'fr-LU',
  'he_IL': 'he-IL',
  'hu_HU': 'hu-HU',
  'it_CH': 'it-CH',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'nb_NO': 'nb-NO',
  'nl_BE': 'nl-BE',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'pt_PT': 'pt-PT',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW',
  'zh_HK': 'zh-Hant-HK'
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar_AE': 'ar-AE',
  'bg_BG': 'bg-BG',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'el_GR': 'el-GR',
  'en_US': 'en-US',
  'en_GB': 'en-GB',
  'en_HK': 'en-HK',
  'en_IL': 'en-IL',
  'es_ES': 'es-ES',
  'es_MX': 'es-MX',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'he_IL': 'he-IL',
  'hr_HR': 'hr-HR',
  'hu_HU': 'hu-HU',
  'id_ID': 'id-ID',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'ms_MY': 'ms-MY',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sr_RS': 'sr-Latn-RS',
  'sv_SE': 'sv-SE',
  'th_TH': 'th-TH',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'vi_VN': 'vi-VN',
  'zh_CN': 'zh-Hans-CN',
  'zh_HK': 'zh-Hant-HK',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'au': 'en-AU', // English (Australia)
  'nz': 'en-NZ' // English (New Zealand)
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ae_ar': 'ar-AE', // Arabic (United Arab Emirates)
  'eg_ar': 'ar-EG', // Arabic (Egypt)
  'kw_ar': 'ar-KW', // Arabic (Kuwait)
  'qa_ar': 'ar-QA', // Arabic (Qatar)
  'mena_ar': 'ar-x-MENA', // Arabic (Middle East and North Africa)
  'bg': 'bg-BG', // Bulgarian (Bulgaria)
  'cz': 'cs-CZ', // Czech (Czech Republic)
  'dk': 'da-DK', // Danish (Denmark)
  'de': 'de-DE', // German (Germany)
  'at': 'de-AT', // German (Austria)
  'ch_de': 'de-CH', // German (Switzerland)
  'lu_de': 'de-LU', // German (Luxembourg)
  'gr_el': 'el-GR', // Greek (Greece)
  'us': 'en-US', // English (United States) - Default Locale
  'ae_en': 'en-AE', // English (United Arab Emirates)
  'au': 'en-AU', // English (Australia)
  'be_en': 'en-BE', // English (Belgium)
  'ca': 'en-CA', // English (Canada)
  'cy_en': 'en-CY', // English (Cyprus)
  'eg_en': 'en-EG', // English (Egypt)
  'uk': 'en-GB', // English (United Kingdom)
  'gr_en': 'en-GR', // English (Greece)
  'hk_en': 'en-HK', // English (Hong Kong)
  'id_en': 'en-ID', // English (Indonesia)
  'ie': 'en-IE', // English (Ireland)
  'il_en': 'en-IL', // English (Israel)
  'in': 'en-IN', // English (India)
  'kw_en': 'en-KW', // English (Kuwait)
  'lu_en': 'en-LU', // English (Luxembourg)
  'mt': 'en-MT', // English (Malta)
  'my_en': 'en-MY', // English (Malaysia)
  'ng': 'en-NG', // English (Nigeria)
  'nz': 'en-NZ', // English (New Zealand)
  'ph_en': 'en-PH', // English (Philippines)
  'sa_en': 'en-SA', // English (Saudi Arabia)
  'sg': 'en-SG', // English (Singapore)
  'qa_en': 'en-QA', // English (Qatar)
  'th_en': 'en-TH', // English (Thailand)
  'vn_en': 'en-VN', // English (Vietnam)
  'za': 'en-ZA', // English (South Africa)
  'africa': 'en-x-AFRICA', // English (Africa)
  'mena_en': 'en-x-MENA', // English (Middle East and North Africa)
  'es': 'es-ES', // Spanish (Spain)
  'ar': 'es-AR', // Spanish (Argentina)
  'cl': 'es-CL', // Spanish (Chile)
  'co': 'es-CO', // Spanish (Colombia)
  'cr': 'es-CR', // Spanish (Costa Rica)
  'ec': 'es-EC', // Spanish (Ecuador)
  'gt': 'es-GT', // Spanish (Guatemala)
  'mx': 'es-MX', // Spanish (Mexico)
  'pe': 'es-PE', // Spanish (Peru)
  'pr': 'es-PR', // Spanish (Puerto Rico)
  'ee': 'et-EE', // Estonian (Estonia)
  'fi': 'fi-FI', // Finnish (Finland)
  'ph_fil': 'fil-PH', // Filipino (Philippines)
  'fr': 'fr-FR', // French (France)
  'be_fr': 'fr-BE', // French (Belgium)
  'ca_fr': 'fr-CA', // French (Canada)
  'ch_fr': 'fr-CH', // French (Switzerland)
  'lu_fr': 'fr-LU', // French (Luxembourg)
  'il_he': 'he-IL', // Hebrew (Israel)
  'in_hi': 'hi-IN', // Hindi (India)
  'hu': 'hu-HU', // Hungarian (Hungary)
  'id_id': 'id-ID', // Indonesian (Indonesia)
  'it': 'it-IT', // Italian (Italy)
  'ch_it': 'it-CH', // Italian (Switzerland)
  'jp': 'ja-JP', // Japanese (Japan)
  'kr': 'ko-KR', // Korean (Korea)
  'lt': 'lt-LT', // Lithuanian (Lithuania)
  'lv': 'lv-LV', // Latvian (Latvia)
  'my_ms': 'ms-MY', // Malay (Malaysia)
  'no': 'nb-NO', // Norwegian (Norway)
  'nl': 'nl-NL', // Dutch (Netherlands)
  'be_nl': 'nl-BE', // Dutch (Belgium)
  'pl': 'pl-PL', // Polish (Poland)
  'br': 'pt-BR', // Portuguese (Brazil)
  'pt': 'pt-PT', // Portuguese (Portugal)
  'ro': 'ro-RO', // Romanian (Romania)
  'ru': 'ru-RU', // Russian (Russia)
  'sk': 'sk-SK', // Slovakian (Slovakia)
  'si': 'sl-SI', // Slovenian (Slovenia)
  'se': 'sv-SE', // Swedish (Sweden)
  'th_th': 'th-TH', // Thai (Thailand)
  'tr': 'tr-TR', // Turkish (Turkey)
  'ua': 'uk-UA', // Ukrainian (Ukraine)
  'vn_vi': 'vi-VN', // Vietnamese (Vietnam)
  'tw': 'zh-Hant-TW', // Chinese Traditional (Taiwan)
  'hk_zh': 'zh-Hant-HK' // Chinese Traditional (Hong Kong)
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar_AE': 'ar-AE',
  'bg_BG': 'bg-BG',
  'ca_ES': 'ca-ES',
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'el_GR': 'el-GR',
  'en_US': 'en-US',
  'es_ES': 'es-ES',
  'et_EE': 'et-EE',
  'fa_IR': 'fa-IR',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'he_IL': 'he-IL',
  'hi_IN': 'hi-IN',
  'ht_HT': 'ht-HT',
  'hu_HU': 'hu-HU',
  'id_ID': 'id-ID',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'ms_MY': 'ms-MY',
  'nl_NL': 'nl-NL',
  'no_NO': 'nb-NO',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'sv_SE': 'sv-SE',
  'th_TH': 'th-TH',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'ur_PK': 'ur-PK',
  'vi_VN': 'vi-VN',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'en_GB': 'en-GB',
  'en_IL': 'en-IL',
  'en_AE': 'en-AE',
  'en_XM': 'en-x-MENA',
  'es_ES': 'es-ES',
  'es_MX': 'es-MX',
  'es_LA': 'es-x-LA',
  'es_NA': 'es-x-NA',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'fr_MA': 'fr-MA',
  'fr_XM': 'fr-x-MENA',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'hu_HU': 'hu-HU',
  'sk_SK': 'sk-SK',
  'sl_SI': 'sl-SI',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'id-ID': 'id-ID',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'ms-MY': 'ms-MY',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'pt-PT': 'pt-PT',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'zh-TW': 'zh-Hant-TW',
  'zh-HK': 'zh-Hant-HK'
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'en': 'en-US', // English (United States)
  'en_GB': 'en-GB', // English (United Kingdom)
  'cs': 'cs-CZ', // Czech (Czech Republic)
  'da': 'da-DK', // Danish (Denmark)
  'de': 'de-DE', // German (Germany)
  'es': 'es-ES', // Spanish (Spain)
  'fi': 'fi-FI', // Finnish (Finland)
  'fr': 'fr-FR', // French (France)
  'it': 'it-IT', // Italian (Italy)
  'ja': 'ja-JP', // Japanese (Japan)
  'ko': 'ko-KR', // Korean (Korea)
  'nb': 'nb-NO', // Norwegian (Norway)
  'nl': 'nl-NL', // Dutch (Netherlands)
  'pl': 'pl-PL', // Polish (Poland)
  'pt': 'pt-BR', // Portuguese (brazil)
  'ru': 'ru-RU', // Russian (Russia)
  'sv': 'sv-SE', // Swedish (Sweden)
  'tr': 'tr-TR', // Turkish (Turkey)
  'uk': 'uk-UA', // Ukranian (Ukraine)
  'zh_Hans': 'zh-Hans-CN', // Chinese Simplified (China)
  'zh_Hant': 'zh-Hant-TW' // Chinese Traditional (Taiwan)
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  en_us: 'en-US', // English (United States)
  en_au: 'en-AU', // English (Australia)
  en_be: 'en-BE', // English (Belgium)
  en_br: 'en-BR', // English (Brazil)
  en_ca: 'en-CA', // English (Canada)
  en_cis: 'en-x-CIS', // English (Commonwealth of Independent States)
  en_cy: 'en-CY', // English (Cyprus)
  en_gb: 'en-GB', // English (United Kingdom)
  en_gr: 'en-GR', // English (Greece)
  en_il: 'en-IL', // English (Israel)
  en_ie: 'en-IE', // English (Ireland)
  en_in: 'en-IN', // English (India)
  en_hk: 'en-HK', // English (Hong Kong)
  en_lu: 'en-LU', // English (Luxembourg)
  en_mena: 'en-x-MENA', // English (Middle East and North Africa)
  en_mt: 'en-MT', // English (Malta)
  en_nz: 'en-NZ', // English (New Zealand)
  en_sea: 'en-x-SEA', // English (Southeast Asia)
  en_za: 'en-ZA', // English (South Africa)
  cs_cz: 'cs-CZ', // Czech (Czech Republic)
  da_dk: 'da-DK', // Danish (Denmark)
  de_de: 'de-DE', // German (Germany)
  de_ch: 'de-CH', // German (Switzerland)
  de_lu: 'de-LU', // German (Luxembourg)
  es_es: 'es-ES', // Spanish (Spain)
  es_419: 'es-x-LA', // Spanish (Latin America)
  es_mx: 'es-MX', // Spanish (Mexico)
  fr_fr: 'fr-FR', // French (France)
  fi_fi: 'fi-FI', // Finnish (Finland)
  fr_ca: 'fr-CA', // French (Canada)
  fr_ch: 'fr-CH', // French (Switzerland)
  fr_be: 'fr-BE', // French (Belgium)
  fr_mena: 'fr-x-MENA', // French (Middle East and North Africa)
  fr_lu: 'fr-LU', // French (Luxembourg)
  it_it: 'it-IT', // Italian (Italy)
  it_ch: 'it-CH', // Italian (Switzerland)
  ja_jp: 'ja-JP', // Japanese (Japan)
  ko_kr: 'ko-KR', // Korean (Korea)
  nb_no: 'nb-NO', // Norwegian (Norway)
  nl_nl: 'nl-NL', // Dutch (Netherlands)
  pl_pl: 'pl-PL', // Polish (Poland)
  pt_pt: 'pt-PT', // Portuguese (Portugal)
  pt_br: 'pt-BR', // Portuguese (Brazil)
  ru_ru: 'ru-RU', // Russian (Russia)
  sv_se: 'sv-SE', // Swedish (Sweden)
  tr_tr: 'tr-TR', // Turkish (Turkey)
  zh_cn: 'zh-Hans-CN', // Chinese Simplified (China)
  zh_tw: 'zh-Hant-TW' // Chinese Traditional (Taiwan)
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cy-GB': 'cy-GB',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pt-BR': 'pt-BR',
  'sv-SE': 'sv-SE',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bn-IN': 'bn-IN',
  'cs-CZ': 'cs-CZ',
  'cy-GB': 'cy-GB',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'el-GR': 'el-GR',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fil-PH': 'fil-PH',
  'fr-FR': 'fr-FR',
  'hi-IN': 'hi-IN',
  'hu-HU': 'hu-HU',
  'hr-HR': 'hr-HR',
  'it-IT': 'it-IT',
  'id-ID': 'id-ID',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'mr-IN': 'mr-IN',
  'ms-MY': 'ms-MY',
  'nb-NO': 'nb-NO',
  'ne-NP': 'ne-NP',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ro-RO': 'ro-RO',
  'sr-SP': 'sr-SP',
  'sv-SE': 'sv-SE',
  'ta-IN': 'ta-IN',
  'te-IN': 'te-IN',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'vi-VN': 'vi-VN',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'ar-AE': 'ar-AE',
  'bg-BG': 'bg-BG',
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'et-EE': 'et-EE',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'he-IL': 'he-IL',
  'hr-HR': 'hr-HR',
  'hu-HU': 'hu-HU',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'lt-LT': 'lt-LT',
  'lv-LV': 'lv-LV',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ro-RO': 'ro-RO',
  'ru-RU': 'ru-RU',
  'sk-SK': 'sk-SK',
  'sl-SI': 'sl-SI',
  'sr-SP': 'sr-Latn-RS',
  'sv-SE': 'sv-SE',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'zh-CN': 'zh-Hans-CN',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-hans': 'zh-Hans-CN',
  'zh-hant': 'zh-Hant-TW'
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'cy': 'cy-GB',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cy-GB': 'cy-GB',
  'en-US': 'en-US',
  'de-DE': 'de-DE',
  'fr-FR': 'fr-FR',
  'es-ES': 'es-ES',
  'it-IT': 'it-IT',
  'pt-BR': 'pt-BR',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'da-DK': 'da-DK',
  'nl-NL': 'nl-NL',
  'sv-SE': 'sv-SE',
  'fi-FI': 'fi-FI',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg': 'bg-BG',
  'cz': 'cs-CZ',
  'dk': 'da-DK',
  'de': 'de-DE',
  'at': 'de-AT',
  'ch_de': 'de-CH',
  'lu_de': 'de-LU',
  'gr_en': 'el-GR',
  'cy_en': 'el-CY',
  'us': 'en-US',
  'be_en': 'en-BE',
  'ca': 'en-CA',
  'au': 'en-AU',
  'uk': 'en-GB',
  'ie': 'en-IE',
  'lu_en': 'en-LU',
  'nz': 'en-NZ',
  'ph': 'en-PH',
  'sg': 'en-SG',
  'es': 'es-ES',
  'ar': 'es-AR',
  'cl': 'es-CL',
  'co': 'es-CO',
  'cr': 'es-CR',
  'ec': 'es-EC',
  'gt': 'es-GT',
  'mx': 'es-MX',
  'pe': 'es-PE',
  've': 'es-VE',
  'ee': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'be_fr': 'fr-BE',
  'ca_fr': 'fr-CA',
  'ch_fr': 'fr-CH',
  'lu_fr': 'fr-LU',
  'il': 'he-IL',
  'in': 'hi-IN',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ch_it': 'it-CH',
  'jp': 'ja-JP',
  'kr': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'mt': 'mt-MT',
  'no': 'nb-NO',
  'nl': 'nl-NL',
  'be_nl': 'nl-BE',
  'pl': 'pl-PL',
  'pt': 'pt-PT',
  'br': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'si': 'sl-SI',
  'se': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'ua': 'uk-UA',
  'tw': 'zh-Hant-TW',
  'hk': 'zh-Hant-HK',
  'id': 'id-ID',
  'my': 'ms-MY'
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ', // Czech - Czech Republic
  'da_DK': 'da-DK', // Danish - Danmark
  'de_AT': 'de-AT', // German - Austria
  'de_CH': 'de-CH', // German - Switzerland
  'de_DE': 'de-DE', // German - Germany
  'de_LU': 'de-LU', // German - Luxembourg
  'en_US': 'en-US', // English - United States
  'cy_EN': 'en-CY', // English - Cyprus
  'be_EN': 'en-BE', // English - Belgium
  'ca_EN': 'en-CA', // English - Canada
  'en_AE': 'en-AE', // English - United Arab Emirates
  'en_AU': 'en-AU', // English - Australia
  'en_BG': 'en-BG', // English - Bulgaria
  'en_BH': 'en-BH', // Bahrain - English
  'en_DZ': 'en-DZ', // English - Algeria
  'en_EE': 'en-EE', // English - Estonia
  'en_EG': 'en-EG', // English - Egypt
  'en_FI': 'en-FI', // English - Finland
  'en_HR': 'en-HR', // Croatia - English
  'en_HU': 'en-HU', // English - Hungary
  'en_ID': 'en-ID', // English - Indonesia
  'en_IE': 'en-IE', // English - Ireland
  'en_IL': 'en-IL', // English - Israel
  'en_JO': 'en-JO', // Jordan - English
  'en_KE': 'en-KE', // English - Kenya
  'en_KW': 'en-KW', // Kuwait - English
  'en_LB': 'en-LB', // Lebanon - English
  'en_LK': 'en-LK', // English - Sri Lanka
  'en_LT': 'en-LT', // English - Lithuania
  'en_LV': 'en-LV', // English - Latvia
  'en_MA': 'en-MA', // English - Morocco
  'en_MT': 'en-MT', // English - Malta
  'en_MY': 'en-MY', // English - Malaysia
  'en_NG': 'en-NG', // English - Nigeria
  'en_NZ': 'en-NZ', // English - New Zealand
  'en_OM': 'en-OM', // Oman - English
  'en_QA': 'en-QA', // Qatar - English
  'en_RO': 'en-RO', // English - Romania
  'en_SA': 'en-SA', // English - Saudi Arabia
  'en_SI': 'en-SI', // English - Slovenia
  'en_SK': 'en-SK', // Slovakian - Slovakia
  'en_TH': 'en-TH', // English - Thailand
  'en_TR': 'en-TR', // English - Turkey
  'en_UA': 'en-UA', // English - Ukraine
  'en_UK': 'en-UK', // English - United Kingdom
  'en_VN': 'en-VN', // English - Vietnam
  'gr_EN': 'en-GR', // English - Greece
  'lu_EN': 'lu-EN', // English - Luxembourg
  'es_ES': 'es-ES', // Spanish - Spain
  'es_BO': 'es-BO', // Spanish - Bolivia
  'es_DO': 'es-DO', // Spanish - Dominican Republic
  'es_MX': 'es-MX', // Spanish - Mexico
  'es_PA': 'es-PA', // Panamá - Spanish
  'es_PY': 'es-PY', // Paraguay - Spanish
  'es_SV': 'es-SV', // El Salvador - Spanish
  'fr_FR': 'fr-FR', // French - France
  'fr_CA': 'fr-CA', // French - Canada
  'fr_BE': 'fr-BE', // French - Belgium
  'fr_CH': 'fr-CH', // French - Switzerland
  'fr_LU': 'fr-LU', // French - Luxembourg
  'fr_MA': 'fr-MA', // French - Marocco
  'it_IT': 'it-IT', // Italian - Italia
  'it_CH': 'it-CH', // Italian - Switzerland
  'ja_JP': 'ja-JP', // Japanese - Japan
  'ko_KR': 'ko-KR', // Korean - South Korea
  'nb_NO': 'nb-NO', // Bokmal Norwegian - Norway
  'nl_NL': 'nl-NL', // Dutch - Nederlands
  'nl_BE': 'nl-BE', // Dutch - Belgium
  'pl_PL': 'pl-PL', // Polish - Poland
  'pt_BR': 'pt-BR', // Brazilan Portuguese - Brazil
  'pt_PT': 'pt-PT', // Portuguese - Portugal
  'ru_RU': 'ru-RU', // Russian - Russia
  'ru_KZ': 'ru-KZ', // Russian - Kazakhstan
  'ru_UZ': 'ru-UZ', // Russian - Uzbekistan
  'sv_SE': 'sv-SE' // Swedish- Sweden
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bg': 'bg-BG',
  'cz': 'cs-CZ',
  'dk': 'da-DK',
  'de': 'de-DE',
  'at': 'de-AT',
  'ch_de': 'de-CH',
  'lu_de': 'de-LU',
  'gr_en': 'el-GR',
  'cy_en': 'el-CY',
  'en': 'en-US',
  'be_en': 'en-BE',
  'ca': 'en-CA',
  'au': 'en-AU',
  'uk': 'en-GB',
  'ie': 'en-IE',
  'lu_en': 'en-LU',
  'nz': 'en-NZ',
  'es': 'es-ES',
  'mx': 'es-MX',
  'ee': 'et-EE',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'be_fr': 'fr-BE',
  'ca_fr': 'fr-CA',
  'ch_fr': 'fr-CH',
  'lu_fr': 'fr-LU',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ch_it': 'it-CH',
  'jp': 'ja-JP',
  'kr': 'ko-KR',
  'lt': 'lt-LT',
  'lv': 'lv-LV',
  'mt': 'mt-MT',
  'no': 'nb-NO',
  'nl': 'nl-NL',
  'be_nl': 'nl-BE',
  'pl': 'pl-PL',
  'pt': 'pt-PT',
  'br': 'pt-BR',
  'ro': 'ro-RO',
  'ru': 'ru-RU',
  'sk': 'sk-SK',
  'si': 'sl-SI',
  'se': 'sv-SE',
  'th': 'th-TH',
  'tr': 'tr-TR',
  'ua': 'uk-UA'
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'pt-BR': 'pt-BR',
  'zh-Hans': 'zh-Hans-CN'
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs-CZ': 'cs-CZ',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'es-MX': 'es-MX',
  'fi-FI': 'fi-FI',
  'fr-CA': 'fr-CA',
  'fr-FR': 'fr-FR',
  'hu-HU': 'hu-HU',
  'id-ID': 'id-ID',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pl-PL': 'pl-PL',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU',
  'sv-SE': 'sv-SE',
  'th-TH': 'th-TH',
  'tr-TR': 'tr-TR',
  'uk-UA': 'uk-UA',
  'vi-VN': 'vi-VN',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://git.corp.adobe.com/CCX/ccx-timeline/tree/develop/src/locale
exports.default = {
  'cs': 'cs-CZ',
  'cy': 'cy-GB',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cy-GB': 'cy-GB',
  'da-DK': 'da-DK',
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fi-FI': 'fi-FI',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'nb-NO': 'nb-NO',
  'nl-NL': 'nl-NL',
  'pt-BR': 'pt-BR',
  'sv-SE': 'sv-SE',
  'zh-Hans-CN': 'zh-Hans-CN',
  'zh-Hant-TW': 'zh-Hant-TW'
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'no': 'nb-NO',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'zh-tw': 'zh-Hant-TW'
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'es': 'es-ES',
  'fi': 'fi-FI',
  'fr': 'fr-FR',
  'hu': 'hu-HU',
  'id': 'id-ID',
  'it': 'it-IT',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'nb': 'nb-NO',
  'nl': 'nl-NL',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'ru': 'ru-RU',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'uk': 'uk-UA',
  'vi': 'vi-VN',
  'zh-Hans': 'zh-Hans-CN',
  'zh-Hant': 'zh-Hant-TW'
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'de_LU': 'de-LU',
  'el_GR': 'el-GR',
  'en_US': 'en-US',
  'en_GB': 'en-GB',
  'es_ES': 'es-ES',
  'et_EE': 'et-EE',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'hu_HU': 'hu-HU',
  'it_IT': 'it-IT',
  'id_ID': 'id-ID',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'pt_PT': 'pt-PT',
  'ro_RO': 'ro-RO',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'th_TH': 'th-TH',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'vi_VN': 'vi-VN',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'es_ES': 'es-ES',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'hu_HU': 'hu-HU',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_PT': 'pt-PT',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'th_TH': 'th-TH',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW',
  'cy_GB': 'cy-GB',
  'ar_AE': 'ar-AE',
  'bg_BG': 'bg-BG',
  'et_EE': 'et-EE',
  'el_GR': 'el-GR',
  'id_ID': 'id-ID',
  'he_IL': 'he-IL',
  'hi_IN': 'hi-IN',
  'lv_LV': 'lv-LV',
  'ms_MY': 'ms-MY',
  'fil_PH': 'fil-PH',
  'ro_RO': 'ro-RO',
  'sk_SK': 'sk-SK',
  'vi_VN': 'vi-VN',
  'sl_SL': 'sl-SL',
  'lt_LT': 'lt-LT'
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'cy_GB': 'cy-GB',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'es_ES': 'es-ES',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_PT': 'pt-PT',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW'
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'cs_CZ': 'cs-CZ',
  'da_DK': 'da-DK',
  'de_DE': 'de-DE',
  'en_US': 'en-US',
  'en_AE': 'en-AE',
  'en_GB': 'en-GB',
  'en_IL': 'en-IL',
  'es_ES': 'es-ES',
  'es_MX': 'es-MX',
  'fi_FI': 'fi-FI',
  'fr_FR': 'fr-FR',
  'fr_CA': 'fr-CA',
  'fr_MA': 'fr-MA',
  'hu_HU': 'hu-HU',
  'it_IT': 'it-IT',
  'ja_JP': 'ja-JP',
  'ko_KR': 'ko-KR',
  'nb_NO': 'nb-NO',
  'nl_NL': 'nl-NL',
  'pl_PL': 'pl-PL',
  'pt_BR': 'pt-BR',
  'ru_RU': 'ru-RU',
  'sv_SE': 'sv-SE',
  'tr_TR': 'tr-TR',
  'uk_UA': 'uk-UA',
  'zh_CN': 'zh-Hans-CN',
  'zh_TW': 'zh-Hant-TW',
  'de_AT': 'de-AT',
  'de_CH': 'de-CH',
  'de_LU': 'de-LU',
  'en_ZA': 'en-x-AFRICA',
  'en_AU': 'en-AU',
  'en_BE': 'en-BE',
  'en_CA': 'en-CA',
  'en_LU': 'en-LU',
  'en_MENA': 'en-x-MENA',
  'en_MT': 'en-MT',
  'en_NZ': 'en-NZ',
  'en_SA': 'en-SA',
  'en_SG': 'en-SG',
  'en_TH': 'en-TH',
  'en_IN': 'en-IN',
  'en_IE': 'en-IE',
  'en_GR': 'en-GR',
  'en_HK': 'en-HK',
  'en_CY': 'en-CY',
  'en_PH': 'en-PH',
  'en_ID': 'en-ID',
  'en_MY': 'en-MY',
  'en_VN': 'en-VN',
  'es_LA': 'es-x-LA',
  'es_CL': 'es-CL',
  'es_AR': 'es-AR',
  'es_PE': 'es-PE',
  'es_CO': 'es-CO',
  'fr_BE': 'fr-BE',
  'fr_CH': 'fr-CH',
  'fr_LU': 'fr-LU',
  'it_CH': 'it-CH',
  'nl_BE': 'nl-BE',
  'pt_PT': 'pt-PT',
  'zh_HK': 'zh-Hant-HK',
  'bg_BG': 'bg-BG',
  'et_EE': 'et-EE',
  'he_IL': 'he-IL',
  'lt_LT': 'lt-LT',
  'lv_LV': 'lv-LV',
  'ar_MENA': 'ar-x-MENA',
  'ar_AE': 'ar-AE',
  'ar_SA': 'ar-SA',
  'ro_RO': 'ro-RO',
  'sl_SL': 'sl-SL',
  'sk_SK': 'sk-SK',
  'th_TH': 'th-TH',
  'fil_PH': 'fil-PH',
  'id_ID': 'id-ID',
  'ms_MY': 'ms-MY',
  'vi_VN': 'vi-VN',
  'hi_IN': 'hi-IN'
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'de-DE': 'de-DE',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'fr-FR': 'fr-FR',
  'it-IT': 'it-IT',
  'ja-JP': 'ja-JP',
  'ko-KR': 'ko-KR',
  'pt-BR': 'pt-BR',
  'ru-RU': 'ru-RU'
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'bn': 'bn-IN',
  'mr': 'mr-IN',
  'ne': 'ne-NP',
  'sr': 'sr-SP',
  'te': 'te-IN',
  'uk': 'uk-UA',
  'pt': 'pt-BR',
  'ar-mena': 'ar-x-MENA',
  'en-africa': 'en-x-AFRICA',
  'en-cis': 'en-x-CIS',
  'en-mena': 'en-x-MENA',
  'en-sea': 'en-x-SEA',
  'es-la': 'es-x-LA',
  'ru-cis': 'ru-x-CIS',
  'zh': 'zh-Hans-CN',
  'es-419': 'es-419',
  'zh-CN': 'zh-Hans-CN',
  'zh-HK': 'zh-Hant-HK',
  'zh-TW': 'zh-Hant-TW'
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'AF': [], // Afghanistan
  'AX': [], // Aland Islands
  'AL': [], // Albania
  'DZ': ['en', 'fr', 'ar'], // Algeria
  'AS': [], // American Samoa
  'AD': ['es', 'fr', 'pt'], // Andorra
  'AO': ['pt'], // Angola
  'AI': [], // Anguilla
  'AQ': ['en'], // Antarctica
  'AG': ['en'], // Antigua And Barbuda
  'AR': ['es'], // Argentina
  'AM': ['en', 'ru'], // Armenia
  'AW': [], // Aruba
  'AU': ['en'], // Australia
  'AT': ['de'], // Austria
  'AZ': ['en', 'ru'], // Azerbaijan
  'BS': ['en'], // Bahamas
  'BH': ['ar', 'en'], // Bahrain
  'BD': [], // Bangladesh
  'BB': ['en'], // Barbados
  'BY': ['ru'], // Belarus
  'BE': ['nl', 'en', 'fr'], // Belgium
  'BZ': [], // Belize
  'BJ': [], // Benin
  'BM': ['en'], // Bermuda
  'BT': [], // Bhutan
  'BO': ['es'], // Bolivia
  'BA': ['en'], // Bosnia And Herzegovina
  'BW': ['en'], // Botswana
  'BV': [], // Bouvet Island
  'BR': ['pt'], // Brazil
  'IO': [], // British Indian Ocean Territory
  'BN': ['en'], // Brunei Darussalam
  'BG': ['bg'], // Bulgaria
  'BF': [], // Burkina Faso
  'BI': ['en', 'fr'], // Burundi
  'KH': [], // Cambodia
  'CM': ['en', 'fr'], // Cameroon
  'CA': ['en', 'fr'], // Canada
  'CV': [], // Cape Verde
  'KY': ['en'], // Cayman Islands
  'CF': [], // Central African Republic
  'TD': [], // Chad
  'CL': ['es'], // Chile
  'CN': ['zh-Hans'], // China
  'CX': [], // Christmas Island
  'CC': ['en'], // Cocos (Keeling) Islands
  'CO': ['es'], // Colombia
  'KM': [], // Comoros
  'CG': ['en', 'fr'], // Congo
  'CD': ['en', 'fr'], // Congo, Democratic Republic
  'CK': [], // Cook Islands
  'CR': ['es'], // Costa Rica
  'CI': ['en', 'fr'], // Cote D'Ivoire
  'HR': ['hr', 'en'], // Croatia
  'CU': [], // Cuba
  'CY': ['en'], // Cyprus
  'CZ': ['cs'], // Czech Republic
  'DK': ['da'], // Denmark
  'DJ': [], // Djibouti
  'DM': ['en'], // Dominica
  'DO': ['es'], // Dominican Republic
  'EC': ['es'], // Ecuador
  'EG': ['ar', 'en'], // Egypt
  'SV': ['es'], // El Salvador
  'GQ': [], // Equatorial Guinea
  'ER': [], // Eritrea
  'EE': ['et'], // Estonia
  'ET': [], // Ethiopia
  'FK': [], // Falkland Islands (Malvinas)
  'FO': ['da'], // Faroe Islands
  'FJ': [], // Fiji
  'FI': ['fi'], // Finland
  'FR': ['fr'], // France
  'GF': ['fr'], // French Guiana
  'PF': [], // French Polynesia
  'TF': [], // French Southern Territories
  'GA': [], // Gabon
  'GM': [], // Gambia
  'GE': ['en', 'ru'], // Georgia
  'DE': ['de'], // Germany
  'GH': ['en'], // Ghana
  'GI': [], // Gibraltar
  'GR': ['el', 'en'], // Greece
  'GL': [], // Greenland
  'GD': [], // Grenada
  'GP': ['en', 'fr'], // Guadeloupe
  'GU': [], // Guam
  'GT': ['es'], // Guatemala
  'GG': [], // Guernsey
  'GN': [], // Guinea
  'GW': [], // Guinea-Bissau
  'GY': ['en'], // Guyana
  'HT': ['en', 'fr'], // Haiti
  'HM': [], // Heard Island & Mcdonald Islands
  'VA': [], // Holy See (Vatican City State)
  'HN': ['es'], // Honduras
  'HK': ['en', 'zh-Hant'], // Hong Kong
  'HU': ['hu'], // Hungary
  'IS': [], // Iceland
  'IN': ['en'], // India
  'ID': ['id', 'en'], // Indonesia
  'IR': [], // Iran, Islamic Republic Of
  'IQ': ['ar'], // Iraq
  'IE': ['en'], // Ireland
  'IM': [], // Isle Of Man
  'IL': ['he', 'en'], // Israel
  'IT': ['it'], // Italy
  'JM': ['en'], // Jamaica
  'JP': ['ja'], // Japan
  'JE': [], // Jersey
  'JO': ['ar', 'en'], // Jordan
  'KZ': ['ru'], // Kazakhstan
  'KE': ['en'], // Kenya
  'KI': [], // Kiribati
  'KR': ['ko'], // Korea
  'KV': [], // Kosovo
  'KW': ['ar', 'en'], // Kuwait
  'KG': ['ru', 'en'], // Kyrgyzstan
  'LA': [], // Lao People\'s Democratic Republic
  'LV': ['lv'], // Latvia
  'LB': ['en', 'ar'], // Lebanon
  'LS': ['en'], // Lesotho
  'LR': ['en'], // Liberia
  'LY': ['ar'], // Libyan Arab Jamahiriya
  'LI': [], // Liechtenstein
  'LT': ['lt'], // Lithuania
  'LU': ['en', 'de', 'fr'], // Luxembourg
  'MO': ['en', 'zh-Hant'], // Macao
  'MK': [], // Macedonia
  'MG': ['en', 'fr'], // Madagascar
  'MW': [], // Malawi
  'MY': ['ms', 'en'], // Malaysia
  'MV': [], // Maldives
  'ML': ['en', 'fr'], // Mali
  'MT': ['en'], // Malta
  'MH': [], // Marshall Islands
  'MQ': ['en', 'fr'], // Martinique
  'MR': ['en', 'fr'], // Mauritania
  'MU': ['en', 'fr'], // Mauritius
  'YT': ['en', 'fr'], // Mayotte
  'MX': ['es'], // Mexico
  'FM': ['en'], // Micronesia, Federated States Of
  'MD': ['en', 'ru'], // Moldova
  'MC': [], // Monaco
  'MN': [], // Mongolia
  'ME': [], // Montenegro
  'MS': [], // Montserrat
  'MA': ['en', 'fr', 'ar'], // Morocco
  'MZ': ['pt'], // Mozambique
  'MM': [], // Myanmar
  'NA': ['en'], // Namibia
  'NR': [], // Nauru
  'NP': [], // Nepal
  'NL': ['nl'], // Netherlands
  'AN': ['nl', 'en'], // Netherlands Antilles
  'NC': [], // New Caledonia
  'NZ': ['en'], // New Zealand
  'NI': ['es'], // Nicaragua
  'NE': ['en', 'fr'], // Niger
  'NG': ['en'], // Nigeria
  'NU': [], // Niue
  'NF': [], // Norfolk Island
  'MP': ['en'], // Northern Mariana Islands
  'NO': ['nb'], // Norway
  'OM': ['ar', 'en'], // Oman
  'PK': ['en'], // Pakistan
  'PW': [], // Palau
  'PS': [], // Palestinian Territory, Occupied
  'PA': ['es'], // Panama
  'PG': [], // Papua New Guinea
  'PY': ['es'], // Paraguay
  'PE': ['es'], // Peru
  'PH': ['en'], // Philippines
  'PN': [], // Pitcairn
  'PL': ['pl'], // Poland
  'PT': ['pt'], // Portugal
  'PR': ['es'], // Puerto Rico
  'QA': ['ar', 'en'], // Qatar
  'RE': [], // Reunion
  'RO': ['ro'], // Romania
  'RU': ['ru'], // Russian Federation
  'RW': [], // Rwanda
  'BL': [], // Saint Barthelemy
  'SH': [], // Saint Helena
  'KN': ['en'], // Saint Kitts And Nevis
  'LC': ['en'], // Saint Lucia
  'MF': [], // Saint Martin
  'PM': [], // Saint Pierre And Miquelon
  'VC': ['pt'], // Saint Vincent And Grenadines
  'WS': [], // Samoa
  'SM': [], // San Marino
  'ST': [], // Sao Tome And Principe
  'SA': ['ar', 'en'], // Saudi Arabia
  'SN': ['en', 'fr'], // Senegal
  'RS': ['rs'], // Serbia
  'SC': [], // Seychelles
  'SL': [], // Sierra Leone
  'SG': ['en'], // Singapore
  'SK': ['sk'], // Slovakia
  'SI': ['sl'], // Slovenia
  'SB': [], // Solomon Islands
  'SO': [], // Somalia
  'ZA': ['en'], // South Africa
  'GS': [], // South Georgia And Sandwich Isl.
  'ES': ['es', 'ca', 'eu'], // Spain
  'LK': ['en'], // Sri Lanka
  'SD': [], // Sudan
  'SR': ['nl'], // Suriname
  'SJ': [], // Svalbard And Jan Mayen
  'SZ': [], // Swaziland
  'SE': ['sv'], // Sweden
  'CH': ['de', 'fr', 'it'], // Switzerland
  'SY': [], // Syrian Arab Republic
  'TW': ['zh-Hant'], // Taiwan
  'TJ': ['ru', 'en'], // Tajikistan
  'TZ': ['en'], // Tanzania
  'TH': ['th', 'en'], // Thailand
  'TL': [], // Timor-Leste
  'TG': [], // Togo
  'TK': [], // Tokelau
  'TO': [], // Tonga
  'TT': ['en'], // Trinidad And Tobago
  'TN': ['en', 'fr', 'ar'], // Tunisia
  'TR': ['tr'], // Turkey
  'TM': ['en', 'ru'], // Turkmenistan
  'TC': ['en'], // Turks And Caicos Islands
  'TV': [], // Tuvalu
  'UG': ['en'], // Uganda
  'UA': ['uk'], // Ukraine
  'AE': ['en', 'ar'], // United Arab Emirates
  'GB': ['en'], // United Kingdom
  'US': ['en'], // United States
  'UM': [], // United States Outlying Islands
  'UY': ['es'], // Uruguay
  'UZ': ['ru', 'en'], // Uzbekistan
  'VU': [], // Vanuatu
  'VE': ['es'], // Venezuela
  'VN': ['vi', 'en'], // Viet Nam
  'VG': ['en'], // Virgin Islands, British
  'VI': [], // Virgin Islands, U.S.
  'WF': [], // Wallis And Futuna
  'EH': [], // Western Sahara
  'YE': ['en', 'ar'], // Yemen
  'ZM': ['en'], // Zambia
  'ZW': ['en'] // Zimbabwe
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _locales = __webpack_require__(3);

var locales = _interopRequireWildcard(_locales);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * @param {string} app - app code. For a complete apps code, see https://git.corp.adobe.com/intl/adobe-locales#supported-apps
 * @returns {array} app supported locale codes. Returns undefined if passed locale is not supported in the app. 
 */
var getAppLocales = function getAppLocales(app) {
  return locales[app] && Object.keys(locales[app]);
}; /*************************************************************************
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2023 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by all applicable intellectual property
   * laws, including trade secret and copyright laws.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/

exports.default = getAppLocales;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GLOBAL_REGION_TRANSLATIONS = undefined;

var _apps = __webpack_require__(2);

var _apps2 = _interopRequireDefault(_apps);

var _utils = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2023 Adobe Systems Incorporated
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe Systems Incorporated and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Adobe Systems Incorporated and its
* suppliers and are protected by all applicable intellectual property
* laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe Systems Incorporated.
**************************************************************************/

var GLOBAL_REGION_CODE = 'ZZ';
var GLOBAL_REGION_TRANSLATIONS = {
  'cs': 'Globální',
  'cy': 'Byd-eang',
  'da': 'Global',
  'de': 'Global',
  'en': 'Global',
  'es': 'Global',
  'fi': 'Kansainvälinen',
  'fr': 'Global',
  'hu': 'Globális',
  'it': 'Globale',
  'ja': 'グローバル',
  'ko': '글로벌',
  'nb': 'Global',
  'nl': 'Wereldwijd',
  'pl': 'Cały świat',
  'pt': 'Global',
  'ru': 'Глобальный',
  'sv': 'Globalt',
  'tr': 'Global',
  'uk': 'Весь світ',
  'zh-Hans': '全球',
  'zh-Hant': '全球'

  /*
   * @param {string} app - app code. For a complete apps code, see https://git.corp.adobe.com/intl/adobe-locales#supported-apps
   * @returns {array} app supported region code or code/name pair. Returns empty array if passed locale is not supported in the app. 
   */
};var getAppRegions = function getAppRegions(app) {
  var withName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var nameLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-US';

  var appSettings = _apps2.default.get(app);
  var regions = appSettings && appSettings.regions || [];

  if (regions.length > 0 && withName === true) {
    var regionNames = Intl.DisplayNames && new Intl.DisplayNames([nameLocale], { type: 'region' });
    var translatedGlobalRegionName = GLOBAL_REGION_TRANSLATIONS[(0, _utils.langScript)(nameLocale, app)] || 'Global';

    return regions.map(function (region) {
      return {
        code: region,
        name: region === GLOBAL_REGION_CODE ? translatedGlobalRegionName : regionNames && regionNames.of(region)
      };
    });
  }

  return regions;
};

exports.default = getAppRegions;
exports.GLOBAL_REGION_TRANSLATIONS = GLOBAL_REGION_TRANSLATIONS;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getLocalizedURL = __webpack_require__(6);

var _getLocalizedURL2 = _interopRequireDefault(_getLocalizedURL);

var _getAppLocaleFromIMS2 = __webpack_require__(5);

var _getAppLocaleFromIMS3 = _interopRequireDefault(_getAppLocaleFromIMS2);

var _utils = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @param {string} url - the destination app url
 * @param {string} locale - locale you want to pass, it doesn not have to be the one destination app uses.
 * @param {string} imsCountryCode - two-character IMS country code
 * @returns {{url: string, match: boolean}}
 */
var getLocalizedURLFromIMS = function getLocalizedURLFromIMS(url, locale, imsCountryCode) {
  var app = (0, _utils.getAppNameFromURL)(url);

  var _getAppLocaleFromIMS = (0, _getAppLocaleFromIMS3.default)(app, locale, imsCountryCode),
      newLocale = _getAppLocaleFromIMS.locale,
      match = _getAppLocaleFromIMS.match;

  return {
    match: match,
    url: (0, _getLocalizedURL2.default)(url, newLocale)
  };
}; /*************************************************************************
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2023 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by all applicable intellectual property
   * laws, including trade secret and copyright laws.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/

exports.default = getLocalizedURLFromIMS;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getAppLocale = __webpack_require__(1);

var _getAppLocale2 = _interopRequireDefault(_getAppLocale);

var _utils = __webpack_require__(0);

var _apps = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @param {string} url - app url
 * @returns {string} locale name the app uses. Returns '' if no valid locale found
 */
var parseLocaleParam = function parseLocaleParam(url) {

  var locale = void 0;

  if (typeof url === 'string') {
    var app = (0, _utils.getAppNameFromURL)(url);

    if (app) {
      // Adobe Account uses 'lang=xx' parameter
      var paramName = _apps.langParamApp.includes(app) ? 'lang' : 'locale';
      var regex = new RegExp('(' + paramName + '=)(.*?)(?=&|$)');

      locale = (url.match(regex) || [])[2] || '';
      locale = (0, _getAppLocale2.default)(app, locale, 'en-US');
    }
  }

  return locale;
}; /*************************************************************************
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2023 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by all applicable intellectual property
   * laws, including trade secret and copyright laws.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
exports.default = parseLocaleParam;

/***/ })
/******/ ]);
});
//# sourceMappingURL=adobe-locales.js.map